function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  let accordion = summary.closest('.accordion');

  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if (accordion) {
    if (summary.nextElementSibling.innerHTML.replace(/(<([^>]+)>)/gi, '').trim() == '') {
      accordion.classList.add('hidden');
    } else {
      accordion.classList.remove('hidden');
    }
  }

  summary.addEventListener('click', (event) => {
    if (event.currentTarget.getAttribute('aria-expanded') === 'true') {
      event.currentTarget.setAttribute('aria-expanded', 'false');
    } else {
      event.currentTarget.setAttribute('aria-expanded', 'true');
    }

    //event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) && elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN'];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', window.location.origin);
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', window.location.origin);
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) => button.addEventListener('click', this.onButtonClick.bind(this)));
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.test = 1;

    this.gradient = this.querySelector('.menu-gradient');

    this.mainDetailsToggle = this.querySelectorAll('details')[0];

    if (this.mainDetailsToggle) {
      if (this.mainDetailsToggle.classList.contains('filter__group')) {
        this.mainDetailsToggle = false;
      }
    }

    this.drawer = this.querySelector('.menu-drawer');

    this.moved = false;

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();

    if (this.nodeName === 'HEADER-DRAWER') {
      this.moved = true;
    }

    if (this.classList.contains('nomove')) {
      this.moved = true;
    }

    if (this.gradient) {
      this.gradient.addEventListener('click', this.forceClose.bind(this));
    }

    this.drawer.addEventListener('touchstart', this.handleTouchStart.bind(this));

    this.drawer.addEventListener('touchend', this.handleTouchEnd.bind(this));
  }

  connectedCallback() {
    if (this.is_header_drawer) return;
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  handleTouchStart(e) {
    if (e.changedTouches) {
      this.touch_start = e.changedTouches[0].screenX;
    } else {
      this.touch_start = e.screenX;
    }
  }

  handleTouchEnd(e) {
    if (e.changedTouches) {
      this.touch_end = e.changedTouches[0].screenX;
    } else {
      this.touch_end = e.screenX;
    }

    this.handleSwipe();
  }

  handleSwipe() {
    const delta = this.touch_start - this.touch_end;

    if (delta < -150) {
      this.close();
    }
  }

  close() {
    this.closeMenuDrawer(true);
  }

  forceClose(e) {
    if (e.target === this.gradient) {
      this.closeMenuDrawer(true);
    }
  }

  bindEvents() {
    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.addEventListener('click', (e) => {
        if (this.mainDetailsToggle.hasAttribute('href')) {
          e.preventDefault();
          window.location.href = this.mainDetailsToggle.getAttribute('href');
        }
      });

      this.mainDetailsToggle.childNodes.forEach((node) => {
        if (node.nodeName === 'SUMMARY') {
          node.addEventListener('click', this.onSummaryClick.bind(this));
        }
      });
    }

    this.querySelectorAll('button:not(.slider-button)').forEach((button) => {
      if (!button.classList.contains('no-trigger')) {
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      }
    });
  }

  onKeyUp(event) {
    if (!event.code || event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('.form__input, button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  setTrigger(trigger) {
    this.trigger = trigger;
  }

  openMenuDrawer(summaryElement) {
    var wishlistPopup = document.querySelector('wishlist-popup');

    if (wishlistPopup) {
      wishlistPopup.hide();
    }

    this.resetScrollPosition();

    if (this.mainDetailsToggle) {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('menu-opening');
      });
      summaryElement.setAttribute('aria-expanded', true);
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    if (this.trigger) {
      this.trigger.setAttribute('aria-expanded', true);
      trapFocus(this.gradient, this.trigger);
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    if (this.gradient) {
      this.gradient.classList.add('open');
    }

    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`menu-drawer-open`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    if (this.mainDetailsToggle) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');

        details.querySelectorAll("summary[aria-expanded='true']").forEach((summary) => {
          summary.setAttribute('aria-expanded', false);
        });
      });

      this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });

      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }

    this.querySelectorAll('.filter__group[open]').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('filter__group--highlight');

      details.querySelectorAll("summary[aria-expanded='true']").forEach((summary) => {
        summary.setAttribute('aria-expanded', false);
      });
    });

    if (this.gradient) {
      this.gradient.classList.remove('open');
    }

    if (this.trigger) {
      this.trigger.setAttribute('aria-expanded', false);

      removeTrapFocus(this.trigger);
    }

    document.body.classList.remove(`overflow-hidden-mobile`);
    document.body.classList.remove(`overflow-hidden-tablet`);
    document.body.classList.remove(`overflow-hidden-desktop`);

    document.body.classList.remove(`menu-drawer-open`);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    if (this.mainDetailsToggle) {
      setTimeout(() => {
        if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
      });
    }
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');

    if (detailsElement) {
      this.closeSubmenu(detailsElement);
    } else {
      const menuGradient = this.querySelector('.menu-gradient');
      if (menuGradient) {
        menuGradient.classList.remove('open');
      }
    }
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }

  resetScrollPosition() {
    this.querySelectorAll('.slider').forEach((slider) => {
      slider.classList.add('scroll-reset');

      setTimeout(() => {
        slider.scrollTo(0, 0);
        slider.classList.remove('scroll-reset');
      }, 1);
    });
  }
}

customElements.define('menu-drawer', MenuDrawer);

class MenuDrawerTrigger extends HTMLElement {
  constructor() {
    super();

    this.trigger = this.querySelector('button');

    if (!this.trigger) return;

    this.menu = document.querySelector(`#${this.trigger.getAttribute('aria-controls')}`);
    this.trigger.addEventListener('click', this.openMenuDrawer.bind(this));
  }

  openMenuDrawer(e) {
    e.preventDefault();

    this.menu.setTrigger(this.trigger);
    this.menu.openMenuDrawer(this.trigger);
  }
}

customElements.define('menu-drawer-trigger', MenuDrawerTrigger);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();

    this.gradient = this.querySelector('.menu-gradient');

    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');

    this.search_trigger = this.querySelector('[data-open-search]');

    if (this.gradient) {
      this.gradient.addEventListener('click', this.forceClose.bind(this));
    } else {
      this.addEventListener('click', this.gradientClose.bind(this));
    }

    if (this.search_trigger) {
      this.search_trigger.addEventListener('click', this.openSearch.bind(this));
    }
  }

  openSearch() {
    super.closeMenuDrawer(this, this.summary);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);

    document.querySelector('#Details-search-drawer-container summary').click();
  }

  gradientClose(e) {
    if (e.target === this.details) {
      super.closeMenuDrawer(this, this.summary);
      this.header.classList.remove('menu-open');
      window.removeEventListener('resize', this.onResize);
    }
  }

  forceClose(e) {
    if (e.target === this.gradient) {
      super.closeMenuDrawer(this, this.summary);
      this.header.classList.remove('menu-open');
      window.removeEventListener('resize', this.onResize);
    }
  }

  openMenuDrawer(summaryElement) {
    this.resetScrollPosition();

    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    //setTimeout(() => {
    this.mainDetailsToggle.classList.add('menu-opening');
    //});

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);

    const detailsElement = summaryElement.parentNode;
    const focus = detailsElement.parentElement.querySelector('.form__input, button');

    if (focus) {
      trapFocus(summaryElement.nextElementSibling, focus);
    } else {
      trapFocus(this.mainDetailsToggle, summaryElement);
    }

    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`menu-drawer-open`);
  }

  closeMenuDrawer(event, elementToFocus) {
    //if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();

    this.preventClose = this.dataset.preventClose === 'true';

    this.close = this.querySelector('.modal-close');

    this.init();

    if (this.close) {
      this.close.addEventListener('click', this.hide.bind(this));
    }
  }

  init() {
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));

    if (!this.preventClose) {
      this.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE') {
          this.hide();
        }
      });
    }

    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else if (!this.preventClose) {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    //window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    //window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;

    this.autoplay = this.dataset.autoplay === 'true';

    poster.addEventListener('click', this.loadContent.bind(this));

    if (this.autoplay) {
      this.loadContent(false);
    }
  }

  loadContent(focus = true) {
    //window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');

    this.initialSlide = this.querySelector('.slider__slide--initial');

    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (this.prevButton) this.prevButton.classList.remove('init');
    if (this.nextButton) this.nextButton.classList.remove('init');

    this.dots = this.querySelectorAll('.slider-counter__link');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this._isPdpFirstSlideLocked = false;
    this._pdpFirstSlideLockRequested = false;
    this._pdpFirstSlideStyles = null;
    this._boundMaintainPdpFirstSlide = this.maintainPdpFirstSlide.bind(this);
    this._boundUnlockPdpFirstSlideLock = this.unlockPdpFirstSlideLock.bind(this);
    this._pdpFirstSlideLockRafId = null;
    this._boundRefreshAfterLoad = this.refreshLayoutState.bind(this);

    if (!this.slider) return;
    this._pdpFirstSlideLockRequested = this.slider.classList.contains('pdp__media') && !this.initialSlide;

    this.initPages();
    // Product card sliders don't need per-instance ResizeObservers.
    // ViewAsToggle + orientation handlers call initPages() for cards on mobile;
    // on desktop, onCardEnter() calls resetPages() after the slider is revealed.
    if (!this.closest('.card')) {
      this._sliderResizeObserver = new ResizeObserver(() => this.initPages());
      this._sliderResizeObserver.observe(this.slider);
      this._slideResizeObserver = new ResizeObserver(() => this.initPages());
      this.observeSlideItems();
    }

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.enableDragToScroll();
    
    // Track programmatic scrolls to prevent duplicate slideChanged events
    this._isProgrammaticScroll = false;

    this.bindNavigationButtons();
    this.schedulePostInitRefresh();

    document.addEventListener('productKnowledge:slideChanged', (e) => {
      const { group, index } = e.detail;

      if (this.dataset.group !== group) return;
      
      const activeSlide = this.slider.querySelectorAll('.slider__slide')[index - 1];
      this.setSlidePosition(activeSlide.offsetLeft);
    });

    this.dispatchSliderReady();
  }

  bindNavigationButtons() {
    if (!this.prevButton || !this.nextButton) {
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
    }
    if (!this.prevButton || !this.nextButton) return;
    this.prevButton.classList.remove('init');
    this.nextButton.classList.remove('init');
    if (this._navButtonsBound) return;

    this._boundOnButtonClick = this.onButtonClick.bind(this);
    this.prevButton.addEventListener('click', this._boundOnButtonClick);
    this.nextButton.addEventListener('click', this._boundOnButtonClick);
    this._navButtonsBound = true;
  }

  schedulePostInitRefresh() {
    requestAnimationFrame(() => this.refreshLayoutState());
    setTimeout(() => this.refreshLayoutState(), 120);
    if (document.readyState === 'complete') {
      this.refreshLayoutState();
    } else {
      window.addEventListener('load', this._boundRefreshAfterLoad, { once: true });
    }
  }

  refreshLayoutState() {
    if (!this.slider || !this.isConnected) return;
    this.bindNavigationButtons();
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.observeSlideItems();
    this.initPages();
  }

  disconnectedCallback() {
    window.removeEventListener('load', this._boundRefreshAfterLoad);
    if (this._sliderResizeObserver) this._sliderResizeObserver.disconnect();
    if (this._slideResizeObserver) this._slideResizeObserver.disconnect();
  }

  observeSlideItems() {
    if (!this._slideResizeObserver) return;
    this._slideResizeObserver.disconnect();
    this.sliderItems.forEach((slide) => this._slideResizeObserver.observe(slide));
  }

  getPdpSlides() {
    if (!this.slider) return [];
    return Array.from(this.slider.querySelectorAll('[id^="Slide-"][data-slide-index]'));
  }

  getPdpActiveSlideState() {
    const slides = this.getPdpSlides();
    if (slides.length === 0 || !this.slider) {
      return {
        slides,
        activeIndex: 0,
        activeSlide: null,
      };
    }

    const scrollLeft = this.slider.scrollLeft;
    let activeIndex = 0;
    let activeSlide = slides[0];
    let nearestDistance = Math.abs((activeSlide?.offsetLeft || 0) - scrollLeft);

    for (let i = 1; i < slides.length; i++) {
      const slide = slides[i];
      const distance = Math.abs(slide.offsetLeft - scrollLeft);
      if (distance < nearestDistance) {
        nearestDistance = distance;
        activeIndex = i;
        activeSlide = slide;
      }
    }

    return {
      slides,
      activeIndex,
      activeSlide,
    };
  }

  getInitialSlidePosition() {
    if (!this.initialSlide) return 0;

    if (!this.slider || !this.slider.classList.contains('rc-content-text__list')) {
      return this.initialSlide.offsetLeft;
    }

    const firstSlide = this.slider.querySelector('.rc-content-text__item');
    const firstSlideOffset = firstSlide ? firstSlide.offsetLeft : 0;

    return Math.max(0, this.initialSlide.offsetLeft - firstSlideOffset);
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    // For PDP media gallery, lock to first slide until user/programmatic navigation.
    const isPdpMediaGallery = this.slider.classList.contains('pdp__media') && !this.initialSlide;
    const shouldLockPdpFirstSlide = isPdpMediaGallery && this._pdpFirstSlideLockRequested;
    if (shouldLockPdpFirstSlide) {
      this.lockPdpFirstSlide();
      this.slider.scrollLeft = 0;
    } else {
      this.unlockPdpFirstSlideLock();
    }

    if (this.sliderItemsToShow.length < 2) {
      if (isPdpMediaGallery) {
        this.totalPages = this.getPdpSlides().length || this.sliderItemsToShow.length;
        this.update();
      } else if (shouldLockPdpFirstSlide) {
        this.update();
      }
      return;
    }

    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    if (isPdpMediaGallery) {
      this.totalPages = this.getPdpSlides().length || this.totalPages;
    }
    
    this.update();

    if (this.initialSlide) {
      this.setSlidePosition(this.getInitialSlidePosition());
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.observeSlideItems();
    this.initPages();
  }

  dispatchSliderReady() {
    this.dispatchEvent(new CustomEvent('slider:ready'));
  }

  lockPdpFirstSlide() {
    if (!this.slider || !this.slider.classList.contains('pdp__media') || this.initialSlide) return;
    this._pdpFirstSlideLockRequested = true;
    if (this._isPdpFirstSlideLocked) return;

    this._pdpFirstSlideStyles = {
      scrollSnapType: this.slider.style.scrollSnapType,
      scrollBehavior: this.slider.style.scrollBehavior,
    };
    this.slider.style.scrollSnapType = 'none';
    this.slider.style.scrollBehavior = 'auto';

    this.slider.addEventListener('scroll', this._boundMaintainPdpFirstSlide, { passive: true });
    this.slider.addEventListener('pointerdown', this._boundUnlockPdpFirstSlideLock, { passive: true });
    this.slider.addEventListener('touchstart', this._boundUnlockPdpFirstSlideLock, { passive: true });
    this.slider.addEventListener('wheel', this._boundUnlockPdpFirstSlideLock, { passive: true });
    this.slider.addEventListener('keydown', this._boundUnlockPdpFirstSlideLock);
    if (this.prevButton) this.prevButton.addEventListener('click', this._boundUnlockPdpFirstSlideLock);
    if (this.nextButton) this.nextButton.addEventListener('click', this._boundUnlockPdpFirstSlideLock);

    this._isPdpFirstSlideLocked = true;
    this.startPdpFirstSlideLockLoop();
  }

  maintainPdpFirstSlide() {
    if (!this._isPdpFirstSlideLocked || !this.slider) return;
    if (this.slider.scrollLeft !== 0) {
      this.slider.scrollLeft = 0;
    }
  }

  startPdpFirstSlideLockLoop() {
    if (this._pdpFirstSlideLockRafId) return;

    const tick = () => {
      if (!this._isPdpFirstSlideLocked) {
        this._pdpFirstSlideLockRafId = null;
        return;
      }

      this.maintainPdpFirstSlide();
      this._pdpFirstSlideLockRafId = requestAnimationFrame(tick);
    };

    this._pdpFirstSlideLockRafId = requestAnimationFrame(tick);
  }

  unlockPdpFirstSlideLock() {
    this._pdpFirstSlideLockRequested = false;
    if (!this._isPdpFirstSlideLocked || !this.slider) return;

    this._isPdpFirstSlideLocked = false;
    if (this._pdpFirstSlideLockRafId) {
      cancelAnimationFrame(this._pdpFirstSlideLockRafId);
      this._pdpFirstSlideLockRafId = null;
    }
    this.slider.removeEventListener('scroll', this._boundMaintainPdpFirstSlide);
    this.slider.removeEventListener('pointerdown', this._boundUnlockPdpFirstSlideLock);
    this.slider.removeEventListener('touchstart', this._boundUnlockPdpFirstSlideLock);
    this.slider.removeEventListener('wheel', this._boundUnlockPdpFirstSlideLock);
    this.slider.removeEventListener('keydown', this._boundUnlockPdpFirstSlideLock);
    if (this.prevButton) this.prevButton.removeEventListener('click', this._boundUnlockPdpFirstSlideLock);
    if (this.nextButton) this.nextButton.removeEventListener('click', this._boundUnlockPdpFirstSlideLock);

    if (this._pdpFirstSlideStyles) {
      this.slider.style.scrollSnapType = this._pdpFirstSlideStyles.scrollSnapType || '';
      this.slider.style.scrollBehavior = this._pdpFirstSlideStyles.scrollBehavior || '';
      this._pdpFirstSlideStyles = null;
    }
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton || !this.prevButton) return;
    const isPdpMediaGallery = this.slider.classList.contains('pdp__media');
    if (!this.sliderItemsToShow || (this.sliderItemsToShow.length === 0 && !isPdpMediaGallery)) return;
    
    const previousPage = this.currentPage;
    
    // Skip slideChanged event during programmatic scrolls but still update button states
    const skipSlideChangedEvent = this._isProgrammaticScroll;
    
    let pdpActiveIndex = 0;
    let pdpSlides = null;

    if (!isPdpMediaGallery && this.sliderItemsToShow.length < 2) {
      this.currentPage = this.sliderItemsToShow.length > 0 ? 1 : 0;

      if (this.currentPageElement && this.pageTotalElement) {
        this.currentPageElement.textContent = this.currentPage;
        this.pageTotalElement.textContent = this.sliderItemsToShow.length;
      }

      if (!this.enableSliderLooping) {
        this.prevButton.setAttribute('disabled', 'disabled');
        this.nextButton.setAttribute('disabled', 'disabled');
      }
      return;
    }
    
    if (isPdpMediaGallery) {
      const { slides, activeIndex, activeSlide } = this.getPdpActiveSlideState();
      pdpSlides = slides;
      pdpActiveIndex = activeIndex;
      this.totalPages = pdpSlides.length || this.totalPages;

      // Use sequential position for currentPage (for array access and display)
      // The slideIndex data attribute is only for thumbnail matching
      this.currentPage = activeIndex + 1;
      
      // Dispatch event with the active slide element
      if (activeSlide && this.currentPage != previousPage && !skipSlideChangedEvent) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: activeSlide,
            },
          })
        );
      }
    } else {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
      
      if (this.currentPage != previousPage && !skipSlideChangedEvent) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: this.sliderItemsToShow[this.currentPage - 1],
            },
          })
        );
      }
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.enableSliderLooping) return;

    if (isPdpMediaGallery) {
      const hasSlides = pdpSlides && pdpSlides.length > 0;
      const isAtStart = !hasSlides || pdpActiveIndex <= 0;
      const isAtEnd = !hasSlides || pdpActiveIndex >= pdpSlides.length - 1;

      if (isAtStart) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (isAtEnd) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    } else {
      if (this.slider.scrollLeft <= 1) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }
    
      const lastSlide = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
      const isLastVisible = this.isSlideVisible(lastSlide);
      
      if (isLastVisible) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }

    if (this.dots.length > 0) {
      this.dots.forEach((dot) => {
        dot.classList.remove('slider-counter__link--active');
      });

      if (this.currentPage && this.dots[this.currentPage - 1]) {
        this.dots[this.currentPage - 1].classList.add('slider-counter__link--active');
      }
    }
  }

  isSlideVisible(element, offset = 0) {
    if (!element || !this.slider) return false;
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    // Add tolerance for sliders with gaps (configured via data-slide-tolerance attribute)
    const tolerance = parseInt(this.dataset.slideTolerance || '0');
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide + tolerance && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    
    // Clear any existing programmatic scroll flag from previous clicks
    this._isProgrammaticScroll = false;
    
    // Track click count for debugging
    if (!this._clickCount) this._clickCount = 0;
    this._clickCount++;
    
    // Check if this is the PDP media gallery with variable-width slides
    const isPdpMediaGallery = this.slider.classList.contains('pdp__media');
    
    if (isPdpMediaGallery) {
      // For variable-width slides, navigate by actual slide positions
      const { slides: allSlides, activeIndex: currentIndex } = this.getPdpActiveSlideState();
      if (allSlides.length === 0) return;
      
      // Calculate target index
      const targetIndex = event.currentTarget.name === 'next' 
        ? Math.min(currentIndex + parseInt(step), allSlides.length - 1)
        : Math.max(currentIndex - parseInt(step), 0);
      
      this.slideScrollPosition = allSlides[targetIndex].offsetLeft;
      
      // Set flag to prevent scroll events from overwriting our manual dispatch
      this._isProgrammaticScroll = true;
      
      // Immediately update currentPage and dispatch slideChanged
      const previousPage = this.currentPage;
      this.currentPage = targetIndex + 1;
      
      if (this.currentPage !== previousPage) {
        this.dispatchEvent(
          new CustomEvent('slideChanged', {
            detail: {
              currentPage: this.currentPage,
              currentElement: allSlides[targetIndex],
            },
          })
        );
      }
    } else {
      // Original logic for uniform-width slides
      this.slideScrollPosition = event.currentTarget.name === 'next' 
        ? this.slider.scrollLeft + step * this.sliderItemOffset 
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    }
    
    this.setSlidePosition(this.slideScrollPosition);
    
    // Clear the flag after scroll animation completes
    setTimeout(() => {
      this._isProgrammaticScroll = false;
    }, 500);
  }

  setSlidePosition(position) {
    if (this._isPdpFirstSlideLocked && position > 0) {
      this.unlockPdpFirstSlideLock();
    }

    const behavior = this.reducedMotion.matches ? 'auto' : this.dataset.scrollBehavior || 'auto';
    this.slider.scrollTo({
      left: position,
      behavior,
    });
  }

  enableDragToScroll() {
    if (!this.slider || !window.matchMedia('(pointer: fine)').matches) return;
    if (!this.slider.id || !this.slider.id.startsWith('Slider-Gallery-')) return;

    // Check if this is the PDP media gallery (variable width slides)
    const isPdpMediaGallery = this.slider.classList.contains('pdp__media');

    let isDragging = false;
    let startX = 0;
    let startScrollLeft = 0;
    let moved = false;
    let pointerId = null;

    let dragDelta = 0;
    let pointerVelocity = 0;
    let velocityRaf = null;
    let lastFrameTime = 0;
    let pointerSamples = [];

    const dragThreshold = 5;
    const snapDragThresholdRatio = parseFloat(this.slider.dataset.snapThresholdRatio) || 0.3;
    const dragSpeed = 1.25;

    // Physics tuning (px/ms)
    const flickThreshold = parseFloat(this.slider.dataset.flickThreshold) || 0.8;
    const frictionPerMs = 0.995;
    const edgeResistance = 0.35;
    const stopVelocityThreshold = 0.02;

    const stopKinetic = () => {
      if (velocityRaf) {
        cancelAnimationFrame(velocityRaf);
        velocityRaf = null;
      }
      this.slider.classList.remove('is-kinetic');
    };

    const cancelDrag = () => {
      stopKinetic();
      if (isDragging) {
        isDragging = false;
        this.slider.classList.remove('is-dragging');
      }
      if (pointerId !== null && typeof this.slider.releasePointerCapture === 'function') {
        if (this.slider.hasPointerCapture && this.slider.hasPointerCapture(pointerId)) {
          this.slider.releasePointerCapture(pointerId);
        }
      }
      pointerId = null;
      dragDelta = 0;
    };

    const addPointerSample = (clientX) => {
      pointerSamples.push({ time: performance.now(), clientX });
      if (pointerSamples.length > 5) pointerSamples.shift();
    };

    const getPointerVelocity = () => {
      if (pointerSamples.length < 2) return 0;
      const last = pointerSamples[pointerSamples.length - 1];
      let first = pointerSamples[0];
      for (let i = pointerSamples.length - 2; i >= 0; i -= 1) {
        if (last.time - pointerSamples[i].time > 60) break;
        first = pointerSamples[i];
      }
      const dt = last.time - first.time;
      if (dt <= 0) return 0;
      return (last.clientX - first.clientX) / dt;
    };

    const applyEdgeResistance = (nextScroll) => {
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      if (nextScroll < 0) {
        return nextScroll * edgeResistance;
      }
      if (nextScroll > maxScroll) {
        return maxScroll + (nextScroll - maxScroll) * edgeResistance;
      }
      return nextScroll;
    };

    const snapToIndex = (index) => {
      if (isPdpMediaGallery) {
        // For variable width slides, query DOM fresh to get all slides
        const allSlides = Array.from(this.slider.querySelectorAll('[id^="Slide-"][data-slide-index]'));
        if (!allSlides[index]) return;
        this.setSlidePosition(allSlides[index].offsetLeft);
        return;
      }
      if (!this.sliderItemOffset) return;
      const maxIndex = Math.max(0, this.sliderItemsToShow.length - 1);
      const clampedIndex = Math.max(0, Math.min(index, maxIndex));
      this.setSlidePosition(clampedIndex * this.sliderItemOffset);
    };

    const snapToNearest = () => {
      if (isPdpMediaGallery) {
        // Query DOM fresh to get all slides for accurate snapping
        const allSlides = Array.from(this.slider.querySelectorAll('[id^="Slide-"][data-slide-index]'));
        const scrollLeft = this.slider.scrollLeft;
        const viewportWidth = this.slider.clientWidth;
        let bestIndex = 0;
        let bestVisibleArea = 0;

        allSlides.forEach((slide, index) => {
          const slideLeft = slide.offsetLeft;
          const slideRight = slideLeft + slide.offsetWidth;
          const viewportRight = scrollLeft + viewportWidth;

          // Calculate visible area of this slide
          const visibleLeft = Math.max(slideLeft, scrollLeft);
          const visibleRight = Math.min(slideRight, viewportRight);
          const visibleArea = Math.max(0, visibleRight - visibleLeft);

          if (visibleArea > bestVisibleArea) {
            bestVisibleArea = visibleArea;
            bestIndex = index;
          }
        });

        snapToIndex(bestIndex);
        return;
      }
      if (!this.sliderItemOffset) return;
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const clamped = Math.max(0, Math.min(this.slider.scrollLeft, maxScroll));
      const index = Math.round(clamped / this.sliderItemOffset);
      snapToIndex(index);
    };

    const snapWithIntent = (velocity) => {
      if (isPdpMediaGallery) {
        // For variable width PDP gallery, snap based on visible slide
        snapToNearest();
        return;
      }
      const startIndex = this.sliderItemOffset ? Math.round(startScrollLeft / this.sliderItemOffset) : 0;
      if (Math.abs(velocity) > flickThreshold) {
        const direction = velocity < 0 ? 1 : -1;
        snapToIndex(startIndex + direction);
        return;
      }
      if (this.sliderItemOffset && Math.abs(dragDelta) >= this.sliderItemOffset * snapDragThresholdRatio) {
        const direction = dragDelta < 0 ? 1 : -1;
        snapToIndex(startIndex + direction);
        return;
      }
      snapToNearest();
    };

    const startKinetic = (scrollVelocity) => {
      if (Math.abs(scrollVelocity) < stopVelocityThreshold) {
        snapWithIntent(pointerVelocity);
        return;
      }

      this.slider.classList.add('is-kinetic');
      let v = scrollVelocity;
      lastFrameTime = performance.now();

      const step = () => {
        const now = performance.now();
        const dt = now - lastFrameTime;
        lastFrameTime = now;

        const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
        const next = applyEdgeResistance(this.slider.scrollLeft + v * dt);
        this.slider.scrollLeft = next;

        v *= Math.pow(frictionPerMs, dt);

        if (Math.abs(v) < stopVelocityThreshold) {
          stopKinetic();
          const clamped = Math.max(0, Math.min(this.slider.scrollLeft, maxScroll));
          this.slider.scrollLeft = clamped;
          snapWithIntent(pointerVelocity);
          return;
        }

        velocityRaf = requestAnimationFrame(step);
      };

      velocityRaf = requestAnimationFrame(step);
    };

    const beginDrag = (clientX, captureEvent) => {
      stopKinetic();
      isDragging = true;
      moved = false;
      startX = clientX;
      startScrollLeft = this.slider.scrollLeft;
      dragDelta = 0;
      pointerSamples = [];
      addPointerSample(clientX);
      this.slider.classList.add('is-dragging');
      if (captureEvent && pointerId !== null && moved) {
        this.slider.setPointerCapture(pointerId);
      }
    };

    const moveDrag = (clientX) => {
      if (!isDragging) return;
      const delta = clientX - startX;
      dragDelta = delta * dragSpeed;
      if (!moved && Math.abs(delta) > dragThreshold) {
        moved = true;
        if (pointerId !== null && this.slider.hasPointerCapture(pointerId) === false) {
          this.slider.setPointerCapture(pointerId);
        }
      }
      const next = applyEdgeResistance(startScrollLeft - dragDelta);
      this.slider.scrollLeft = next;
      addPointerSample(clientX);
      pointerVelocity = getPointerVelocity();
    };

    const endDrag = () => {
      if (!isDragging) return;
      isDragging = false;
      this.slider.classList.remove('is-dragging');

      const scrollVelocity = -pointerVelocity * dragSpeed;
      startKinetic(scrollVelocity);

      if (moved) {
        this.preventClick = true;
        window.setTimeout(() => {
          this.preventClick = false;
        }, 0);
      }
    };

    if (window.PointerEvent) {
      const onPointerDown = (event) => {
        if (event.button !== 0) return;
        if (event.pointerType && event.pointerType !== 'mouse') return;
        pointerId = event.pointerId;
        beginDrag(event.clientX, false);
      };

      const onPointerMove = (event) => {
        if (event.pointerId !== pointerId) return;
        moveDrag(event.clientX);
        if (moved) event.preventDefault();
      };

      const onPointerUp = (event) => {
        if (event.pointerId !== pointerId) return;
        if (isDragging) this.slider.releasePointerCapture(pointerId);
        pointerId = null;
        endDrag();
      };

      this.slider.addEventListener('pointerdown', onPointerDown);
      this.slider.addEventListener('pointermove', onPointerMove);
      this.slider.addEventListener('pointerup', onPointerUp);
      this.slider.addEventListener('pointercancel', onPointerUp);
    } else {
      const onMouseDown = (event) => {
        if (event.button !== 0) return;
        beginDrag(event.clientX, false);
      };

      const onMouseMove = (event) => {
        moveDrag(event.clientX);
        if (isDragging) event.preventDefault();
      };

      const onMouseUp = () => {
        endDrag();
      };

      this.slider.addEventListener('mousedown', onMouseDown);
      window.addEventListener('mousemove', onMouseMove);
      window.addEventListener('mouseup', onMouseUp);
    }

    this.slider.addEventListener('dragstart', (event) => event.preventDefault());
    this.slider.addEventListener('zoom:open', cancelDrag);

    this.slider.addEventListener(
      'click',
      (event) => {
        if (!this.preventClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      if (index === this.currentPage - 1) {
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantRadios extends HTMLElement {
  constructor() {
    super();

    // Get parent with class
    this.productInfo = this.closest('product-info');

    this.originalStyle = this.dataset.handle;
    this.currentStyle = this.dataset.handle;
    this.styleId = this.dataset.styleId;
    this.cacheId = `${this.dataset.styleId}-${window.cacheModifier}`;
    this.updateUrl = this.dataset.updateUrl == 'true';
    this.sectionId = this.dataset.section;
    this.styleUrl = `${window.routes.style_collections}?filter.p.tag=style-id:${this.styleId}`;

    this.template = this.dataset.template;

    this.variants = JSON.parse(this.querySelector(`#ProductVariants-${this.sectionId}`).textContent);

    this.groups = [];
    this.swatchOrder = this.dataset.swatchOrder ? this.dataset.swatchOrder.split(',') : [];
    this.fieldsets = this.querySelectorAll('fieldset');
    this.swatchLists = this.querySelectorAll('[data-color-list]');
    this._styleRequestController = null;
    this._styleRequestId = 0;
    this._optionRequestController = null;
    this._optionRequestId = 0;

    this.addEventListener('change', this.onVariantChange);
    this.addEventListener('mouseover', this.onMouseOver);
    if (window.innerWidth >= 750) {
      this.addEventListener('mouseout', this.onMouseOut);
    }

    this.init();

    if (this.updateUrl) {
      //window.addEventListener('popstate', (e) => {
      //  this.selectStyle(e.state ? e.state.style : this.originalStyle);
      //});
    }
  }

  init() {
    fetch(`${this.styleUrl}&section_id=component_style-swatches`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const swatches = html.querySelectorAll('.product__swatch');

        var swatchesArray = Array.from(swatches);
        
        // Convert swatches to use images instead of color backgrounds for PDP
        // Only convert if the swatch has an image available
        swatchesArray.forEach((swatch) => {
          const swatchImage = swatch.querySelector('.product__swatch-image');
          if (swatchImage && swatchImage.src && !swatchImage.src.includes('Liquid error')) {
            swatch.classList.add('product__swatch--image');
            swatch.removeAttribute('style'); // Remove background color
            swatchImage.classList.remove('hidden');
          }
        });

        if (this.swatchOrder.length > 0) {
          swatchesArray.sort((a, b) => {
            const aIndex = this.swatchOrder.indexOf(a.dataset.swatch);
            const bIndex = this.swatchOrder.indexOf(b.dataset.swatch);

            if (aIndex === -1 && bIndex === -1) return 0;
            if (aIndex === -1) return 1;
            if (bIndex === -1) return -1;

            return aIndex - bIndex;
          });
        }

        /*
        this.swatchLists.forEach((swatchList) => {
          const colorList = swatchList.dataset.colorList.toLowerCase();

          swatches.forEach((swatch) => {
            var color = swatch.dataset.color;
            var label = swatch.querySelector('label');
            var input = swatch.querySelector('input');

            input.setAttribute('name', `style-${this.sectionId}-${this.currentStyle}`);
            input.setAttribute('id', `StyleSwatch-${this.sectionId}-${this.currentStyle}-${color}`);

            label.setAttribute('for', `StyleSwatch-${this.sectionId}-${this.currentStyle}-${color}`);

            if (colorList.includes(swatch.dataset.color.toLowerCase()) && swatch.dataset.loaded === 'false') {
              if (swatch.dataset.handle === this.currentStyle) {
                this.currentColor = swatch.dataset.color;
                swatch.querySelector('input').checked = true;
              }

              if (swatch.querySelector('variant-tooltip')) {
                swatch.querySelector('variant-tooltip').remove();
              }

              swatchList.appendChild(swatch);
              swatch.dataset.loaded = 'true';
            }
          });
        });
        */

        swatchesArray.forEach((swatch) => {

          if (swatch.dataset.group != '') {
            if (!this.groups.includes(swatch.dataset.group)) {
              this.groups.push(swatch.dataset.group);

              var fieldset = document.createElement('fieldset');
              fieldset.classList.add('product__variant', 'product__variant--style');
              fieldset.setAttribute('data-group', swatch.dataset.group);

              fieldset.innerHTML = `
                <legend class="product__variant-option subtitle subtitle--small">
                  <label class="product__variant-label subtitle">
                    ${swatch.dataset.group}:
                    <span class="product__variant-option--selected body subtitle--lowercase">
                      ${swatch.dataset.handle === this.currentStyle ? swatch.dataset.color : ''}
                    </span>
                  </label>
                </legend>
                <div class="product__swatch-list" data-color-list=""></div>
              `;

              this.insertBefore(fieldset, this.querySelector('.product__options'));

              this.fieldsets = this.querySelectorAll('fieldset');
              this.swatchLists = this.querySelectorAll('[data-color-list]');
            } else {
              var fieldset = this.querySelector(`fieldset[data-group="${swatch.dataset.group}"]`);
            }

            this.insertSwatch(swatch, fieldset.querySelector('[data-color-list]'));
          }

          if (swatch.dataset.loaded === 'false') {
            this.insertSwatch(swatch, this.swatchLists[0]);
          }
        });

        this.swatchLists.forEach((swatchList) => {
          if (swatchList.innerHTML == '') {
            swatchList.parentElement.classList.add('hidden');
          }
        });

        this.colorSwatches = this.querySelectorAll('[data-color-list] .product__swatch');
        
        // Re-initialize slider components after swatches are loaded
        this.querySelectorAll('slider-component').forEach((slider) => {
          if (slider.resetPages) {
            slider.resetPages();
          }
        });
        
        // Scroll to checked swatch after brief delay for slider initialization
        setTimeout(() => {
          this.scrollToCheckedSwatch();
        }, 300);
      });
  }

  scrollToCheckedSwatch() {
    const sliders = this.querySelectorAll('slider-component');
    
    if (sliders.length > 0) {
      // PDP: Has slider-component wrappers
      sliders.forEach((slider) => {
        // Make sure slider is visible and has dimensions before scrolling
        if (!slider.slider || slider.slider.clientWidth === 0) {
          setTimeout(() => this.scrollToCheckedSwatch(), 100);
          return;
        }
        
        const checkedSwatch = slider.querySelector('.product__swatch input:checked');
        
        if (checkedSwatch) {
          const swatchElement = checkedSwatch.closest('.product__swatch');
          if (swatchElement && slider.slider) {
            // Keep the selected swatch aligned to the left to preserve the overflow peek.
            const scrollLeft = swatchElement.offsetLeft;

            // Only scroll when the movement is meaningful to avoid jitter.
            if (Math.abs(slider.slider.scrollLeft - scrollLeft) > 5) {
              slider.slider.scrollTo({
                left: scrollLeft,
                behavior: 'auto'
              });
            }
          }
        }
        
        // Force update to enable/disable buttons based on scroll position
        if (slider.update) {
          slider.update();
        }
      });
    } else {
      // QuickView: No slider-component, scroll the swatch-list div directly
      const swatchLists = this.querySelectorAll('.product__swatch-list[data-color-list]');
      
      swatchLists.forEach((swatchList) => {
        const checkedSwatch = swatchList.querySelector('.product__swatch input:checked');
        
        if (checkedSwatch) {
          const swatchElement = checkedSwatch.closest('.product__swatch');
          if (swatchElement) {
            // Keep the selected swatch aligned to the left to preserve the overflow peek.
            const scrollLeft = swatchElement.offsetLeft;

            // Only scroll when the movement is meaningful to avoid jitter.
            if (Math.abs(swatchList.scrollLeft - scrollLeft) > 5) {
              swatchList.scrollTo({
                left: scrollLeft,
                behavior: 'auto'
              });
            }
          }
        }
      });
    }
  }

  insertSwatch(swatch, swatchList) {
    if (swatch.dataset.handle === this.currentStyle) {
      this.currentColor = swatch.dataset.color;
      swatch.querySelector('input').checked = true;
    }

    if (swatch.querySelector('variant-tooltip')) {
      swatch.querySelector('variant-tooltip').remove();
    }

    swatchList.appendChild(swatch);
    swatch.dataset.loaded = 'true';
  }

  onVariantChange(e) {
    const input = e.target;

    this.removeErrorMessage();

    if (input.getAttribute('name').indexOf('style') > -1) {
      this.fetchStyleInfo(input);
    } else {
      this.fetchOptionInfo(input);
    }
  }

  selectStyle(style) {
    this.colorSwatches.forEach((swatch) => {
      const input = swatch.querySelector('input');

      this.removeErrorMessage();

      if (input.value == style) {
        input.checked = true;
        this.fetchStyleInfo(input, false);
      } else {
        input.checked = false;
      }
    });
  }

  fetchStyleInfo(input, pushState = true) {
    const style = input.dataset.style;
    this.currentStyle = style;
    this.currentColor = input.dataset.color;
    const requestId = ++this._styleRequestId;

    if (this._styleRequestController) {
      this._styleRequestController.abort();
    }
    const controller = new AbortController();
    this._styleRequestController = controller;
    if (this._optionRequestController) {
      this._optionRequestController.abort();
      this._optionRequestController = null;
    }

    const productId = input.dataset.productId;
    const seasonalBadge = input.closest('.product__swatch').dataset.seasonalBadge;
    
    /** Update color label immediately with seasonal badge **/
    const selectedSpan = input.closest('.product__variant').querySelector('.product__variant-option--selected');
    if (selectedSpan) {
      selectedSpan.innerHTML = this.currentColor;
      if (seasonalBadge) {
        selectedSpan.innerHTML += `<span class="product__seasonal-badge">${seasonalBadge}</span>`;
      }
    }

    fetch(`/products/${style}?section_id=${this.sectionId}`, { signal: controller.signal })
      .then((response) => response.text())
      .then((responseText) => {
        if (requestId !== this._styleRequestId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const main = html.querySelector(`[id^=MainProduct-]`);

        if (main) {
          if (main.dataset.template != this.template) {
            window.location.href = `/products/${style}`;
            return;
          }
        }

        /** Variant Data **/
        this.variants = JSON.parse(html.querySelector(`#ProductVariants-${this.sectionId}`).textContent);

        /** Selected Color Display **/
        const legendSource = html.querySelector('.product__variant--style legend');
        const legendDestination = input.closest('.product__variant').querySelector('legend');
        if (legendSource && legendDestination) {
          legendDestination.innerHTML = legendSource.innerHTML;
        }

        /** History **/
        if (this.updateUrl && pushState) {
          window.history.replaceState({ style: style }, '', `/products/${style}`);
        }

        /** Price **/
        this.setPrice(html);

        /** Discount Badge **/
        this.setDiscountBadge(html);

        /** Gallery **/
        const gallerySource = html.getElementById(`MediaGallery-${this.sectionId}`);
        const galleryDestination = document.getElementById(`MediaGallery-${this.sectionId}`);

        if (gallerySource && galleryDestination) {
          galleryDestination.replaceWith(gallerySource);

          if (customElements.get('media-gallery')) {
            customElements.upgrade(gallerySource);
          }

          requestAnimationFrame(() => {
            if (typeof gallerySource.resetViewerToFirstSlide === 'function') {
              gallerySource.resetViewerToFirstSlide();
              return;
            }

            gallerySource.dispatchEvent(
              new CustomEvent('media-gallery:style-changed', {
                bubbles: true,
                detail: {
                  sectionId: this.sectionId,
                  style,
                  requestId,
                },
              })
            );
          });
        }

        /** Linked Products **/
        const linkedSource = html.getElementById(`ProductLink-${this.sectionId}`);
        const linkedDestination = document.getElementById(`ProductLink-${this.sectionId}`);

        if (linkedSource && linkedDestination) linkedDestination.innerHTML = linkedSource.innerHTML;

        /** modal media **/
        const modalSource = html.getElementById(`ProductModal-${this.sectionId}`);
        const modalDestination = document.getElementById(`ProductModal-${this.sectionId}`);

        if (modalSource && modalDestination) {
          modalDestination.innerHTML = modalSource.innerHTML;

          const modalInstance = document.querySelector('modal-dialog');
          if (modalInstance && typeof modalInstance.init === 'function') {
            modalInstance.init();
          }
        }

        /** Text **/
        const textSources = html.querySelectorAll(`.product__text`);

        textSources.forEach((textSource) => {
          const blockId = textSource.dataset.blockId;

          const textDestination = this.productInfo.querySelector(`.product__text[data-block-id='${blockId}']`);

          if (textDestination) {
            textDestination.innerHTML = textSource.innerHTML;

            if (textSource.classList.contains('hidden')) {
              textDestination.classList.add('hidden');
            } else {
              textDestination.classList.remove('hidden');
            }
          }
        });

        this.productInfo.rebindLinks();

        /** Messages **/
        const messageSources = html.querySelectorAll(`.product__bundle-message`);

        messageSources.forEach((messageSource) => {
          const blockId = messageSource.dataset.blockId;

          const messageDestination = this.productInfo.querySelector(`.product__bundle-message[data-block-id='${blockId}']`);

          if (messageDestination) {
            messageDestination.innerHTML = messageSource.innerHTML;
          }
        });

        /** Title **/
        const titleSource = html.getElementById(`Title-${this.sectionId}`);
        const titleDestination = document.getElementById(`Title-${this.sectionId}`);

        if (titleSource && titleDestination) titleDestination.innerHTML = titleSource.innerHTML;

        // Also update mobile title
        const titleMobileDestination = document.getElementById(`Title-Mobile-${this.sectionId}`);
        if (titleSource && titleMobileDestination) titleMobileDestination.innerHTML = titleSource.innerHTML;

        /** Breadcrumbs **/
        const breadcrumbsSource = html.getElementById(`Breadcrumbs-${this.sectionId}`);
        const breadcrumbsDestination = document.getElementById(`Breadcrumbs-${this.sectionId}`);

        if (breadcrumbsSource && breadcrumbsDestination) breadcrumbsDestination.innerHTML = breadcrumbsSource.innerHTML;

        // Also update mobile breadcrumbs
        const breadcrumbsMobileSource = html.getElementById(`Breadcrumbs-Mobile-${this.sectionId}`);
        const breadcrumbsMobileDestination = document.getElementById(`Breadcrumbs-Mobile-${this.sectionId}`);

        if (breadcrumbsMobileSource && breadcrumbsMobileDestination) breadcrumbsMobileDestination.innerHTML = breadcrumbsMobileSource.innerHTML;

        /** Tags **/
        const tagsSource = html.getElementById(`Tags-${this.sectionId}`);
        const tagsDestination = document.getElementById(`Tags-${this.sectionId}`);

        if (tagsSource && tagsDestination) tagsDestination.innerHTML = tagsSource.innerHTML;

        // Also update mobile tags
        const tagsMobileSource = html.getElementById(`Tags-Mobile-${this.sectionId}`);
        const tagsMobileDestination = document.getElementById(`Tags-Mobile-${this.sectionId}`);

        if (tagsMobileSource && tagsMobileDestination) tagsMobileDestination.innerHTML = tagsMobileSource.innerHTML;

        /** Preorder Message */
        const preorderSource = html.getElementById(`ProductPreorderMessage-${this.sectionId}`);
        const preorderrDestination = document.getElementById(`ProductPreorderMessage-${this.sectionId}`);

        if (preorderSource && preorderrDestination) preorderrDestination.innerHTML = preorderSource.innerHTML;

        /** Properties **/
        const propertiesSource = html.getElementById(`PropertyTags-${this.sectionId}`);
        const propertiesDestination = document.getElementById(`PropertyTags-${this.sectionId}`);

        if (propertiesSource && propertiesDestination) propertiesDestination.innerHTML = propertiesSource.innerHTML;

        /** Options */
        const optionsSource = html.getElementById(`ProductOptions-${this.sectionId}`);
        const optionsDestination = document.getElementById(`ProductOptions-${this.sectionId}`);

        if (optionsSource && optionsDestination) optionsDestination.innerHTML = optionsSource.innerHTML;

        this.currentVariant = this.getCurrentVariant();

        /** Share URL **/
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (shareButton && shareButton.updateUrl) {
          shareButton.updateUrl(`${window.shopUrl}/products/${style}`);
        }

        /** Login Button */
        const accountSource = html.getElementById(`CustomerAccountProduct-${this.sectionId}`);
        const accountDestination = document.getElementById(`CustomerAccountProduct-${this.sectionId}`);

        if (accountSource && accountDestination) accountDestination.innerHTML = accountSource.innerHTML;

        /** Wishlist Button **/
        const wishlistSource = html.getElementById(`ProductWishlistButton-${this.sectionId}`);
        const wishlistDestination = document.getElementById(`ProductWishlistButton-${this.sectionId}`);

        if (wishlistSource && wishlistDestination) wishlistDestination.innerHTML = wishlistSource.innerHTML;

        // Also update mobile wishlist button
        const wishlistMobileSource = html.getElementById(`ProductWishlistButton-Mobile-${this.sectionId}`);
        const wishlistMobileDestination = document.getElementById(`ProductWishlistButton-Mobile-${this.sectionId}`);

        if (wishlistMobileSource && wishlistMobileDestination) wishlistMobileDestination.innerHTML = wishlistMobileSource.innerHTML;

        if (typeof Wishlist == 'object') {
          Wishlist.loadButtons();
        }

        /** Submit button **/
        this.setSubmitButton(html);

        const quickSource = html.getElementById(`ProductQuickviewButton-${this.sectionId}`);
        const quickDestination = document.getElementById(`ProductQuickviewButton-${this.sectionId}`);

        if (quickSource && quickDestination) {
          quickDestination.innerHTML = quickSource.innerHTML;
          quickDestination.setAttribute('href', quickSource.getAttribute('href'));

          if (quickSource.hasAttribute('disabled')) {
            quickDestination.setAttribute('disabled', true);
          } else {
            quickDestination.removeAttribute('disabled');
          }
        }

        /** Recommendations */
        const recommendationsSource = html.getElementById(`ProductRecommendations-${this.sectionId}`);
        const recommendationsDestination = document.getElementById(`ProductRecommendations-${this.sectionId}`);

        if (recommendationsSource && recommendationsDestination) {
          recommendationsDestination.setAttribute('data-url', recommendationsSource.dataset.url);
          recommendationsDestination.load();
        }

        /** Complete the Look */
        const completeLookSource = html.getElementById(`ProductRecommendations-${this.sectionId}-complete-look`);
        const completeLookDestination = document.getElementById(`ProductRecommendations-${this.sectionId}-complete-look`);

        if (completeLookSource && completeLookDestination) {
          completeLookDestination.setAttribute('data-url', completeLookSource.dataset.url);
          completeLookDestination.load();
        }

        /** Notice **/
        const noticeSource = html.getElementById(`ProductNotice-${this.sectionId}`);
        const noticeDestination = document.getElementById(`ProductNotice-${this.sectionId}`);

        if (noticeSource && noticeDestination) noticeDestination.innerHTML = noticeSource.innerHTML;

        /** Bundle **/
        const bundleSource = html.getElementById(`BundleMessage-${this.sectionId}`);
        const bundleDestination = document.getElementById(`BundleMessage-${this.sectionId}`);

        if (bundleSource && bundleDestination) bundleDestination.innerHTML = bundleSource.innerHTML;

        /** Accordions **/
        const accordionSources = html.querySelectorAll(`.product__accordion`);

        accordionSources.forEach((accordionSource) => {
          const accordionDestination = document.getElementById(`${accordionSource.getAttribute('id')}`);

          if (accordionDestination) {
            accordionDestination.querySelector('.accordion__title').innerHTML = accordionSource.querySelector('.accordion__title').innerHTML;
            accordionDestination.querySelector('.accordion__content').innerHTML = accordionSource.querySelector('.accordion__content').innerHTML;
          }
        });

        /** Recommendations */
        const relatedProducts = document.querySelector('#ProductRecommendations-PDP');

        if (relatedProducts) {
          relatedProducts.setAttribute(
            'data-url',
            `${window.routes.recommendations_url}?section_id=${relatedProducts.dataset.sectionId}&product_id=${productId}&limit=${relatedProducts.dataset.limit}`
          );
          relatedProducts.load();
        }

        /** Size guide **/
        if (this.dataset.quickview == 'true') {
          const sizeGuideSource = html.querySelector(`#SizeGuide-Quickview .menu-drawer`);
          const sizeGuideDestination = document.querySelector(`#SizeGuide-Quickview .menu-drawer`);

          if (sizeGuideSource && sizeGuideDestination) {
            sizeGuideDestination.innerHTML = sizeGuideSource.innerHTML;
          }
        } else {
          const sizeGuideSource = html.querySelector(`#SizeGuide-${this.sectionId} .menu-drawer`);
          const sizeGuideDestination = document.querySelector(`#SizeGuide-${this.sectionId} .menu-drawer`);

          if (sizeGuideSource && sizeGuideDestination) {
            sizeGuideDestination.innerHTML = sizeGuideSource.innerHTML;
          }
        }

        /** Id **/
        this.setId(html);

        /** Other Additional Sections **/
        if (this.updateUrl) {
          const additionalSections = document.querySelectorAll('#MainContent .shopify-section');

          additionalSections.forEach((section) => {
            if (!section.classList.contains('section__no-load')) {
              fetch(`/products/${style}?section_id=${section.getAttribute('id').replace('shopify-section-', '')}`)
                .then((response) => response.text())
                .then((responseText) => {
                  const html = new DOMParser().parseFromString(responseText, 'text/html');

                  const sectionSource = html.querySelector(`#${section.getAttribute('id')} div`);
                  const sectionDestination = section.querySelector('div');

                  if (sectionSource && sectionDestination) {
                    sectionDestination.innerHTML = sectionSource.innerHTML;
                  }
                });
            }
          });

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              //variant: this.currentVariant,
            },
          });

          enableZoomOnHover(2);
        }

        if (this.currentVariant) this.fetchOptionInfo();
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        console.error(error);
      })
      .finally(() => {
        if (requestId === this._styleRequestId) {
          this._styleRequestController = null;
        }
      });
  }

  fetchOptionInfo(input) {
    this.currentVariant = this.getCurrentVariant();
    if (!this.currentVariant) return;

    const requestId = ++this._optionRequestId;
    if (this._optionRequestController) {
      this._optionRequestController.abort();
    }
    const controller = new AbortController();
    this._optionRequestController = controller;

    fetch(`/products/${this.currentStyle}?variant=${this.currentVariant.id}&section_id=${this.sectionId}`, { signal: controller.signal })
      .then((response) => response.text())
      .then((responseText) => {
        if (requestId !== this._optionRequestId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        /** Price **/
        this.setPrice(html);

        /** Discount Badge **/
        this.setDiscountBadge(html);

        /** Breadcrumbs **/
        const breadcrumbsSource = html.getElementById(`Breadcrumbs-${this.sectionId}`);
        const breadcrumbsDestination = document.getElementById(`Breadcrumbs-${this.sectionId}`);

        if (breadcrumbsSource && breadcrumbsDestination) breadcrumbsDestination.innerHTML = breadcrumbsSource.innerHTML;

        // Also update mobile breadcrumbs
        const breadcrumbsMobileSource = html.getElementById(`Breadcrumbs-Mobile-${this.sectionId}`);
        const breadcrumbsMobileDestination = document.getElementById(`Breadcrumbs-Mobile-${this.sectionId}`);

        if (breadcrumbsMobileSource && breadcrumbsMobileDestination) breadcrumbsMobileDestination.innerHTML = breadcrumbsMobileSource.innerHTML;

        /** History **/
        if (this.updateUrl) {
          window.history.replaceState({ style: this.currentStyle }, '', `/products/${this.currentStyle}?variant=${this.currentVariant.id}`);
        }

        /** Wishlist **/
        const wishlistSource = html.getElementById(`ProductWishlistButton-${this.sectionId}`);
        const wishlistDestination = document.getElementById(`ProductWishlistButton-${this.sectionId}`);

        if (wishlistSource && wishlistDestination) wishlistDestination.innerHTML = wishlistSource.innerHTML;

        // Also update mobile wishlist button
        const wishlistMobileSource = html.getElementById(`ProductWishlistButton-Mobile-${this.sectionId}`);
        const wishlistMobileDestination = document.getElementById(`ProductWishlistButton-Mobile-${this.sectionId}`);

        if (wishlistMobileSource && wishlistMobileDestination) wishlistMobileDestination.innerHTML = wishlistMobileSource.innerHTML;

        if (typeof Wishlist == 'object') {
          Wishlist.loadButtons();
        }

        const wishlistNewPopupSource = html.getElementById(`WishlistNewListPopup-${this.sectionId}`);
        const wishlistNewPopupDestination = document.getElementById(`WishlistNewListPopup-${this.sectionId}`);

        if (wishlistNewPopupSource && wishlistNewPopupDestination) wishlistNewPopupDestination.innerHTML = wishlistNewPopupSource.innerHTML;

        /** Properties **/
        const propertiesSource = html.getElementById(`PropertyTags-${this.sectionId}`);
        const propertiesDestination = document.getElementById(`PropertyTags-${this.sectionId}`);

        if (propertiesSource && propertiesDestination) propertiesDestination.innerHTML = propertiesSource.innerHTML;

        /** Tags **/
        const tagsSource = html.getElementById(`Tags-${this.sectionId}`);
        const tagsDestination = document.getElementById(`Tags-${this.sectionId}`);

        if (tagsSource && tagsDestination) tagsDestination.innerHTML = tagsSource.innerHTML;

        // Also update mobile tags
        const tagsMobileSource = html.getElementById(`Tags-Mobile-${this.sectionId}`);
        const tagsMobileDestination = document.getElementById(`Tags-Mobile-${this.sectionId}`);

        if (tagsMobileSource && tagsMobileDestination) tagsMobileDestination.innerHTML = tagsMobileSource.innerHTML;

        /** Preorder Message */
        const preorderSource = html.getElementById(`ProductPreorderMessage-${this.sectionId}`);
        const preorderrDestination = document.getElementById(`ProductPreorderMessage-${this.sectionId}`);

        if (preorderSource && preorderrDestination) preorderrDestination.innerHTML = preorderSource.innerHTML;

        /** Submit button **/
        this.setSubmitButton(html);

        /** Id **/
        this.setId(html);

        /** Size Guide **/
        if (this.dataset.quickview == 'true') {
          this.sizeGuide = document.querySelector(`#SizeGuide-Quickview size-guide`);
        } else {
          this.sizeGuide = document.querySelector(`#SizeGuide-${this.sectionId} size-guide`);
        }

        if (this.sizeGuide) {
          let option1 = this.currentVariant.option1;

          this.sizeGuide.setSize(option1);
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            html,
            variant: this.currentVariant,
          },
        });

        /** Complete the Look */
        const completeLook = document.getElementById(`ProductRecommendations-${this.sectionId}-complete-look`);
        if (completeLook) {
          const source = html.getElementById(`ProductRecommendations-${this.sectionId}-complete-look`);
          if (source) {
            completeLook.setAttribute('data-url', source.dataset.url);
            completeLook.load();
          }
        }
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        console.error(error);
      })
      .finally(() => {
        if (requestId === this._optionRequestId) {
          this._optionRequestController = null;
        }
      });
  }

  getCurrentVariant() {
    var options = [];
    var currentVariant = false;

    this.querySelectorAll('.product__swatch-radio--options:checked').forEach((input) => {
      options.push(input.value);
    });

    this.variants.forEach((variant) => {
      if (JSON.stringify(variant.options) === JSON.stringify(options)) {
        currentVariant = variant;
        return false;
      }
    });

    return currentVariant;
  }

  onMouseOver(e) {
    let target = e.target;
    let sibling = target.previousElementSibling;

    if (sibling && sibling.disabled) {
      return;
    }

    if (target.classList.contains('product__swatch-label--style')) {
      // Swap out the color group with the current hovered color.
      let color = target.parentElement.dataset.color;
      let seasonalBadge = target.parentElement.dataset.seasonalBadge;
      let container = target.closest('.product__variant');
      if (!container) return;
      let selectedSpan = container.querySelector('.product__variant-option--selected');
      if (!selectedSpan) return;

      selectedSpan.innerHTML = color;
      if (seasonalBadge) {
        selectedSpan.innerHTML += `<span class="product__seasonal-badge">${seasonalBadge}</span>`;
      }
    } else if (target.classList.contains('product__swatch-label--options')) {
      let container = target.closest('.product__variant');
      if (!container) return;
      const selectedLabel = container.querySelector('.product__variant-option--selected');
      if (!selectedLabel) return;
      let label = target.getAttribute('data-label');
      let option_name = target.getAttribute('data-option-name');
      let quantity = parseInt(target.getAttribute('data-variant-quantity'));
      let preorder = target.getAttribute('data-preorder') == 'true';
      let string = label;
      if (option_name.toLowerCase() == 'size') {
        if (quantity == 0 && !preorder) {
          //string = `${label} - Sold Out`;
        } else if (quantity <= 5) {
          // Low stock left // item left
          //string = `${label} - ${quantity} item${quantity == 1 ? '' : 's'} left`;
        }
      }
      // Todo: causes console errors
      selectedLabel.innerHTML = string;
    }
  }

  onMouseOut(e) {
    if (e.target.classList.contains('product__swatch-label--style')) {
      // Clear the color group.
      let container = e.target.closest('.product__variant');
      if (!container) return;
      let selectedSpan = container.querySelector('.product__variant-option--selected');
      if (!selectedSpan) return;
      selectedSpan.innerHTML = '';

      // Show the current color in its own color group
      let selectedInput = this.querySelector('.product__swatch-radio--style:checked');
      if (!selectedInput) return;
      let selectedSwatch = selectedInput.closest('.product__swatch');
      if (!selectedSwatch) return;
      selectedSpan = selectedInput.closest('.product__variant')?.querySelector('.product__variant-option--selected');
      if (!selectedSpan) return;
      let seasonalBadge = selectedSwatch.dataset.seasonalBadge;
      
      selectedSpan.innerHTML = this.currentColor;
      if (seasonalBadge) {
        selectedSpan.innerHTML += `<span class="product__seasonal-badge">${seasonalBadge}</span>`;
      }
    } else if (e.target.classList.contains('product__swatch-label--options')) {
      let container = e.target.closest('.product__variant');
      if (!container) return;
      const selectedLabel = container.querySelector('.product__variant-option--selected');
      if (!selectedLabel) return;
      let current = container.querySelector('.product__swatch-radio:checked');

      if (current) {
        selectedLabel.innerHTML = current.value;
      } else {
        selectedLabel.innerHTML = '';
      }
    }
  }

  setSubmitButton(html) {
    const submitSource = html.getElementById(`ProductFormButton-${this.sectionId}`);
    const submitDestination = document.getElementById(`ProductFormButton-${this.sectionId}`);

    if (submitSource && submitDestination) {
      submitDestination.innerHTML = submitSource.innerHTML;
    }

    /*
    if (submitSource && submitDestination) {
      submitDestination.querySelector('span').innerHTML = submitSource.querySelector('span').innerHTML;

      if (submitSource.hasAttribute('onclick')) {
        submitDestination.setAttribute('onclick', submitSource.getAttribute('onclick'));
      } else {
        submitDestination.removeAttribute('onclick');
      }

      if (submitSource.hasAttribute('disabled')) {
        submitDestination.setAttribute('disabled', true);
      } else {
        submitDestination.removeAttribute('disabled');
      }
    }

    const dynamicSource = html.getElementById(`ProductDynamicButton-${this.sectionId}`);
    const dynamicDestination = document.getElementById(`ProductDynamicButton-${this.sectionId}`);

    if (dynamicSource && dynamicDestination) {
      if (submitSource.hasAttribute('disabled')) {
        dynamicDestination.classList.add('hidden');
      } else {
        dynamicDestination.classList.remove('hidden');
      }

      if (dynamicSource.classList.contains('enabled')) {
        dynamicDestination.classList.add('enabled');
      } else {
        dynamicDestination.classList.remove('enabled');
      }
    }
    */
  }

  setPrice(html) {
    const priceSource = html.getElementById(`Price-${this.sectionId}`);
    const priceDestination = document.getElementById(`Price-${this.sectionId}`);

    if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;

    // Also update mobile price
    const priceMobileSource = html.getElementById(`Price-Mobile-${this.sectionId}`);
    const priceMobileDestination = document.getElementById(`Price-Mobile-${this.sectionId}`);
    if (priceMobileSource && priceMobileDestination) priceMobileDestination.innerHTML = priceMobileSource.innerHTML;

    const price = document.getElementById(`Price-${this.sectionId}`);
    if (price) price.classList.remove('hidden');
  }

  setDiscountBadge(html) {
    const badgeSource = html.getElementById(`DiscountBadge-${this.sectionId}`);
    const badgeDestination = document.getElementById(`DiscountBadge-${this.sectionId}`);

    if (badgeSource && badgeDestination) {
      badgeDestination.innerHTML = badgeSource.innerHTML;
      if (badgeSource.classList.contains('hidden')) {
        badgeDestination.classList.add('hidden');
      } else {
        badgeDestination.classList.remove('hidden');
      }
    }

    // Also update mobile discount badge
    const badgeMobileSource = html.getElementById(`DiscountBadge-Mobile-${this.sectionId}`);
    const badgeMobileDestination = document.getElementById(`DiscountBadge-Mobile-${this.sectionId}`);

    if (badgeMobileSource && badgeMobileDestination) {
      badgeMobileDestination.innerHTML = badgeMobileSource.innerHTML;
      if (badgeMobileSource.classList.contains('hidden')) {
        badgeMobileDestination.classList.add('hidden');
      } else {
        badgeMobileDestination.classList.remove('hidden');
      }
    }
  }

  setId(html) {
    if (this.currentVariant) {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }
}

customElements.define('variant-radios', VariantRadios);

window.swatchCache = window.swatchCache || {};
window.swatchFetchPromises = window.swatchFetchPromises || {};
window.cardGalleryCache = window.cardGalleryCache || {};
window.cardGalleryFetchPromises = window.cardGalleryFetchPromises || {};
window.cardGalleryPrefetchState = window.cardGalleryPrefetchState || { active: 0, max: 2, queue: [] };
window.cardSwatchInstanceId = window.cardSwatchInstanceId || 0;

class CardSwatches extends HTMLElement {
  constructor() {
    super();

    this.swatchCount = 0;

    this.container = this.parentElement;
    this.card = this.closest('.card');
    this.isIOS = /iP(ad|hone|od)/.test(navigator.userAgent);

    this.originalStyle = this.dataset.handle;
    this.currentStyle = this.dataset.handle;
    this.pendingStyle = null;
    this.instanceId = ++window.cardSwatchInstanceId;
    this.styleId = this.dataset.styleId;
    this.cacheId = `${this.dataset.styleId}-${window.cacheModifier}`;
    this.sectionId = this.dataset.section;

    this.displayType = this.dataset.displayImage;
    this.hoverType = this.dataset.hoverImage;

    this.moreSwatchesNum = 3;
    
    this.priceContainer = this.container.querySelector('.card__content-price');
    this.originalPrice = this.priceContainer.innerHTML;

    localStorage.removeItem(`${this.dataset.styleId}-${parseInt(window.cacheModifier) - 1}`);

    this.link = this.card ? this.card.querySelector(`#ProductCardLink-${this.sectionId}-${this.originalStyle}`) : null;
    this.linkTitle = this.card ? this.card.querySelector(`#ProductCardTitleLink-${this.sectionId}-${this.originalStyle}`) : null;
    this.mediaContainer = this.link ? this.link.querySelector('.media') : null;
    this.quickview = this.card ? this.card.querySelector(`#ProductQuickview-${this.sectionId}-${this.originalStyle}`) : null;

    this.viewAs = document.querySelector(`view-as-toggle`);

    if (this.viewAs) {
      this.mediaProduct = this.link.querySelector('.media--product');
      this.mediaModel = this.link.querySelector('.media--model');
      this.sliderComponent = this.link.querySelector('.content-slider');
      this.controlWrapper = this.sliderComponent ? this.sliderComponent.querySelector('.slideshow__control-wrapper') : null;
      // Save original Liquid-rendered HTML (includes lifestyle overrides) for clean card-leave restoration
      this.originalMediaProductHTML = this.mediaProduct ? this.mediaProduct.innerHTML : null;
      this.originalMediaModelHTML = this.mediaModel ? this.mediaModel.innerHTML : null;

    }

    this._originalSliderHTML = null;
    this._originalDotsHTML = null;
    this._mobileGalleryRequestId = 0;
    this._initStarted = false;
    this._visibleSwatchPrefetchToken = null;
    this._visibleSwatchPrefetchMode = null;
    this._swatchLoadingShowTimer = null;
    this._swatchLoadingHideTimer = null;
    this._swatchLoadingVisibleAt = 0;
    this._swatchPointerFallbackTimer = null;
    this._swatchClickFallbackTimer = null;
    this._lastVariantChangeStyle = null;
    this._lastVariantChangeAt = 0;
    this._lastManualSwatchSelectionStyle = null;
    this._lastManualSwatchSelectionAt = 0;
    this.dataset.swatchesLoading = 'true';
    if (window.innerWidth < 750) {
      const _initSliderList = this.link && this.link.querySelector('[id^="Slider-"]');
      if (_initSliderList) this._originalSliderHTML = _initSliderList.innerHTML;
      const _initControlWrapper = this.sliderComponent && this.sliderComponent.querySelector('.slideshow__control-wrapper');
      if (_initControlWrapper) this._originalDotsHTML = _initControlWrapper.innerHTML;
      this.addEventListener('pointerdown', this.onSwatchPointerDown, { passive: true });
      this.addEventListener('click', this.onSwatchClick);
    }

    this.defaultMedia = false;
    this.productMedia = false;
    this.modelMedia = false;

    this.styleUrl = `${window.routes.style_collections}?filter.p.tag=style-id:${this.styleId}`;
    
    this.imageOverride = this.dataset.imageOverride;
    this.lifestyleMediaHTML = null;
    this.lifestyleMediaProductHTML = null;
    this.lifestyleMediaModelHTML = null;
    if (this.imageOverride && this.dataset.inLifestyleCollection == 'true') {
      if (this.mediaContainer) this.lifestyleMediaHTML = this.mediaContainer.innerHTML;
      if (this.mediaProduct) this.lifestyleMediaProductHTML = this.mediaProduct.innerHTML;
      if (this.mediaModel) this.lifestyleMediaModelHTML = this.mediaModel.innerHTML;
    }

    // Attach mouseenter/mouseleave listeners for hover logic, but only to the image (.card__media)
    if (window.innerWidth >= 750 && this.viewAs && this.card && !this.card.classList.contains('card--simple')) {
      const cardMedia = this.card.querySelector('.card__media');
      if (cardMedia) {
        cardMedia.addEventListener('mouseenter', this.onCardEnter.bind(this));
        cardMedia.addEventListener('mouseleave', this.onCardLeave.bind(this));
      }
    } else if (window.innerWidth >= 750 && !this.viewAs && this.card) {
      // No-toggle cards: instantly reset slider scroll on mouse leave so the next hover always starts from the first slide.
      this.card.addEventListener('mouseleave', () => {
        const sliderList = this.link && this.link.querySelector('[id^="Slider-"]');
        if (sliderList) {
          sliderList.style.scrollBehavior = 'auto';
          sliderList.scrollLeft = 0;
        }
      });
    }

    this.addEventListener('change', this.onVariantChange);

    // Attach swatch hover listeners on desktop so hovering a non-primary
    // swatch shows its variant image (off-model) without needing to hover
    // the card image first.
    if (window.innerWidth >= 750) {
      this.addEventListener('mouseover', this.onMouseOver);
      this.addEventListener('mouseout', this.onMouseOut);
    }

    // Defer init() until the card enters the viewport so that all N cards on
    // a large collection page don't fire simultaneous fetch() calls on load.
    if (this.card) {
      const lazyInitObserver = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          lazyInitObserver.disconnect();
          this.init();
        }
      }, { rootMargin: window.innerWidth < 750 ? '900px 0px' : '200px' });
      lazyInitObserver.observe(this.card);
    } else {
      this.init();
    }

    // Mobile: reset when the card scrolls out of view
    if (window.innerWidth < 750 && this.card) {
      this._scrollAwayObserver = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) {
          const sliderList = this.link && this.link.querySelector('[id^="Slider-"]');
          const isSwiped = sliderList && sliderList.scrollLeft > 0;
          if (this.currentStyle !== this.originalStyle || isSwiped) {
            this._resetMobileSlider();
          }
        }
      }, { threshold: 0 });
      this._scrollAwayObserver.observe(this.card);
    }
  }

  pauseCardVideos() {
    if (!this.card) return;
    this.card.querySelectorAll('video').forEach((video) => {
      try {
        video.pause();
      } catch (e) {}
    });
  }

  rebuildVideo(video) {
    if (!video || !video.parentElement) return video;

    const parent = video.parentElement;
    const rebuilt = document.createElement('video');

    for (const attr of video.attributes) {
      try {
        rebuilt.setAttribute(attr.name, attr.value);
      } catch (e) {
        // skip attributes with invalid names (e.g. stray " from unescaped product titles)
      }
    }

    rebuilt.dataset.rcRebuilt = 'true';
    rebuilt.muted = true;
    rebuilt.playsInline = true;

    video.querySelectorAll('source').forEach((source) => {
      const newSource = document.createElement('source');
      if (source.src) newSource.src = source.src;
      if (source.type) newSource.type = source.type;
      rebuilt.appendChild(newSource);
    });

    parent.replaceChild(rebuilt, video);
    return rebuilt;
  }

  swapVideoSources(container, newVideo) {
    if (!container || !newVideo) return false;
    const existing = container.querySelector('video');
    if (!existing) return false;

    const poster = newVideo.getAttribute('poster');
    if (poster) existing.setAttribute('poster', poster);
    existing.setAttribute('aria-label', newVideo.getAttribute('aria-label') || '');

    while (existing.firstChild) existing.removeChild(existing.firstChild);
    newVideo.querySelectorAll('source').forEach((source) => {
      const newSource = document.createElement('source');
      if (source.src) newSource.src = source.src;
      if (source.type) newSource.type = source.type;
      existing.appendChild(newSource);
    });

    this.ensureCardVideoAutoplay(existing);
    return true;
  }

  ensureCardVideoAutoplay(video) {
    if (!video) return;

    if (this.isIOS && !video.dataset.rcRebuilt) {
      video = this.rebuildVideo(video);
    }

    // iOS Safari is sensitive to timing on dynamically inserted videos.
    video.muted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.autoplay = true;
    video.setAttribute('autoplay', '');
    video.preload = 'auto';
    video.setAttribute('preload', 'auto');

    const attemptPlay = () => {
      if (!video.isConnected) return;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.then === 'function') {
        playPromise.catch(() => {});
      }
    };

    // Register retry listeners before play() — video.paused is false immediately
    // after play() per spec, so checking it afterwards misses the retry window.
    video.addEventListener('loadeddata', () => { if (video.paused) attemptPlay(); }, { once: true });
    video.addEventListener('canplay', () => { if (video.paused) attemptPlay(); }, { once: true });
    setTimeout(() => { if (video.paused) attemptPlay(); }, 150);
    requestAnimationFrame(() => { if (video.paused) attemptPlay(); });

    // Trigger resource loading if the video has no data yet (e.g. was in
    // display:none since page load). Without this, play() stalls on readyState=0.
    if (video.readyState < 2) video.load();

    // Attempt immediately (keeps iOS user-gesture allowance).
    attemptPlay();
  }

  getCachedSwatchList() {
    if (window.swatchCache[this.cacheId]) {
      return window.swatchCache[this.cacheId];
    }

    const cached = sessionStorage.getItem(this.cacheId);
    if (!cached) return null;

    try {
      const parsed = JSON.parse(cached);
      const swatchList = Array.isArray(parsed) ? parsed : Object.values(parsed);
      if (swatchList.length) {
        window.swatchCache[this.cacheId] = swatchList;
        return swatchList;
      }
    } catch (error) {
    }

    sessionStorage.removeItem(this.cacheId);
    return null;
  }

  persistSwatchList(swatchList) {
    if (!Array.isArray(swatchList) || !swatchList.length) return;

    window.swatchCache[this.cacheId] = swatchList;

    try {
      sessionStorage.setItem(this.cacheId, JSON.stringify(swatchList));
    } catch (error) {
    }
  }

  renderSwatchList(swatchList) {
    if (!Array.isArray(swatchList)) return;

    this.innerHTML = '';
    this.classList.remove('hidden');
    this.dataset.swatchesLoading = 'false';
    this.dataset.swatchesReady = 'true';
    this.swatchCount = 0;

    swatchList.forEach((swatchMarkup, index) => {
      const swatch = new DOMParser().parseFromString(swatchMarkup, 'text/html').querySelector('.product__swatch');
      if (!swatch) return;

      const label = swatch.querySelector('label');
      const input = swatch.querySelector('input');

      if (!label || !input) return;

      input.setAttribute('name', `style-${this.sectionId}-${this.instanceId}`);
      input.setAttribute('id', `StyleSwatch-${this.sectionId}-${this.instanceId}-${index}`);

      label.setAttribute('for', `StyleSwatch-${this.sectionId}-${this.instanceId}-${index}`);

      if (swatch.dataset.handle === this.currentStyle) {
        this.prepend(swatch);

        if (!this.productMedia) {
          this.productMedia = swatch.querySelector(`template[data-media='variant-image']`);
        }

        if (!this.modelMedia) {
          this.modelMedia = swatch.querySelector(`template[data-media='1']`);
        }

        if (!this.defaultMedia) {
          if (this.displayType == 'variant') {
            this.defaultMedia = swatch.querySelector(`template[data-media='variant-image']`);
          } else if (this.displayType == '0') {
            this.defaultMedia = swatch.querySelector(`template[data-media='0']`);
          } else if (this.displayType == '1') {
            this.defaultMedia = swatch.querySelector(`template[data-media='1']`);
          }
        }
      } else if (this.swatchCount < (this.moreSwatchesNum - 1)) {
        this.swatchCount++;
        this.appendChild(swatch);
      }

      swatch.dataset.loaded = 'true';
    });

    if (this.innerHTML == '') {
      this.dataset.swatchesReady = 'false';
      this.classList.add('hidden');
      return;
    }

    if (swatchList.length > this.moreSwatchesNum) {
      const div = document.createElement('div');
      div.classList.add('product__swatch');
      div.classList.add('product__swatch--more');
      div.innerHTML = `<a href="/products/${this.currentStyle}" class="product__swatch-label product__swatch-label--style">+${swatchList.length - this.moreSwatchesNum}</a>`;
      this.appendChild(div);
    }

    this.syncSwatchSelectionState();
  }

  fetchSwatchList() {
    if (window.swatchFetchPromises[this.cacheId]) {
      return window.swatchFetchPromises[this.cacheId];
    }

    window.swatchFetchPromises[this.cacheId] = fetch(`${this.styleUrl}&section_id=component_style-swatches`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const swatchList = Array.from(html.querySelectorAll('.product__swatch')).map((swatch) => swatch.outerHTML);
        this.persistSwatchList(swatchList);
        return swatchList;
      })
      .finally(() => {
        delete window.swatchFetchPromises[this.cacheId];
      });

    return window.swatchFetchPromises[this.cacheId];
  }

  normalizeMobileGallery(data) {
    const rawMedia = data.media && data.media.length ? data.media : null;

    if (rawMedia) {
      return rawMedia
        .filter((mediaItem) => mediaItem.media_type === 'image' || mediaItem.media_type === 'video')
        .slice(1, 6)
        .map((mediaItem) => {
          if (mediaItem.media_type === 'video') {
            return {
              media_type: 'video',
              alt: mediaItem.alt || '',
              poster: mediaItem.preview_image && mediaItem.preview_image.src ? mediaItem.preview_image.src : '',
              sources: (mediaItem.sources || []).map((source) => ({
                url: source.url,
                mime_type: source.mime_type
              }))
            };
          }

          return {
            media_type: 'image',
            src: mediaItem.src || (mediaItem.preview_image && mediaItem.preview_image.src) || '',
            alt: mediaItem.alt || (mediaItem.preview_image && mediaItem.preview_image.alt) || ''
          };
        })
        .filter((mediaItem) => {
          if (mediaItem.media_type === 'video') return mediaItem.sources.length;
          return !!mediaItem.src;
        });
    }

    if (data.images && data.images.length) {
      return data.images.slice(1, 6).map((url) => ({ media_type: 'image', src: url, alt: '' }));
    }

    return [];
  }

  getMobileGallery(handle) {
    if (!handle) return Promise.resolve([]);

    if (window.cardGalleryCache[handle]) {
      return Promise.resolve(window.cardGalleryCache[handle]);
    }

    if (window.cardGalleryFetchPromises[handle]) {
      return window.cardGalleryFetchPromises[handle];
    }

    window.cardGalleryFetchPromises[handle] = fetch(`/products/${handle}.js`)
      .then((response) => response.json())
      .then((data) => {
        const mediaList = this.normalizeMobileGallery(data);
        if (mediaList.length) {
          window.cardGalleryCache[handle] = mediaList;
        }
        return mediaList;
      })
      .finally(() => {
        delete window.cardGalleryFetchPromises[handle];
      });

    return window.cardGalleryFetchPromises[handle];
  }

  prefetchMobileGallery(handle) {
    if (!handle || window.innerWidth >= 750) return;
    if (navigator.connection && navigator.connection.saveData) return;

    this.getMobileGallery(handle).catch(() => {});
  }

  queueMobileGalleryPrefetch(handle) {
    if (!handle || window.innerWidth >= 750) return;
    if (navigator.connection && navigator.connection.saveData) return;
    if (window.cardGalleryCache[handle] || window.cardGalleryFetchPromises[handle]) return;

    const state = window.cardGalleryPrefetchState;
    if (state.queue.includes(handle)) return;
    if (state.queue.length >= 6) return;

    state.queue.push(handle);
    this._drainMobileGalleryPrefetchQueue();
  }

  _drainMobileGalleryPrefetchQueue() {
    const state = window.cardGalleryPrefetchState;
    while (state.active < state.max && state.queue.length > 0) {
      const handle = state.queue.shift();
      if (!handle || window.cardGalleryCache[handle] || window.cardGalleryFetchPromises[handle]) continue;

      state.active += 1;
      this.getMobileGallery(handle)
        .catch(() => {})
        .finally(() => {
          state.active = Math.max(0, state.active - 1);
          this._drainMobileGalleryPrefetchQueue();
        });
    }
  }

  prefetchVisibleAlternateSwatch() {
    if (window.innerWidth >= 750 || !this.card) return;
    if (navigator.connection && navigator.connection.saveData) return;

    const rect = this.card.getBoundingClientRect();
    if (rect.bottom < -100 || rect.top > window.innerHeight + 300) return;

    const nextHandle = Array.from(this.querySelectorAll('.product__swatch-radio--style'))
      .map((input) => input.dataset.style)
      .find((style) => style && style !== this.currentStyle);

    if (nextHandle) {
      this.queueMobileGalleryPrefetch(nextHandle);
    }
  }

  scheduleVisibleSwatchPrefetch() {
    if (window.innerWidth >= 750 || !this.card) return;
    if (navigator.connection && navigator.connection.saveData) return;
    if (this._visibleSwatchPrefetchToken) return;

    const callback = () => {
      this._visibleSwatchPrefetchToken = null;
      this._visibleSwatchPrefetchMode = null;
      this.prefetchVisibleAlternateSwatch();
    };

    if ('requestIdleCallback' in window) {
      this._visibleSwatchPrefetchMode = 'idle';
      this._visibleSwatchPrefetchToken = window.requestIdleCallback(callback, { timeout: 400 });
      return;
    }

    this._visibleSwatchPrefetchMode = 'timeout';
    this._visibleSwatchPrefetchToken = window.setTimeout(callback, 180);
  }

  cancelVisibleSwatchPrefetch() {
    if (!this._visibleSwatchPrefetchToken) return;

    if (this._visibleSwatchPrefetchMode === 'idle' && 'cancelIdleCallback' in window) {
      window.cancelIdleCallback(this._visibleSwatchPrefetchToken);
    } else if (this._visibleSwatchPrefetchMode === 'timeout') {
      window.clearTimeout(this._visibleSwatchPrefetchToken);
    }

    this._visibleSwatchPrefetchToken = null;
    this._visibleSwatchPrefetchMode = null;
  }

  setMobileSwatchLoading(isLoading) {
    const showOverlay = () => {
      this._swatchLoadingShowTimer = null;
      this._swatchLoadingVisibleAt = Date.now();
      if (this.card) {
        this.card.dataset.swatchLoading = 'true';
      }
    };

    if (this._swatchLoadingHideTimer) {
      clearTimeout(this._swatchLoadingHideTimer);
      this._swatchLoadingHideTimer = null;
    }

    if (this.sliderComponent) {
      this.sliderComponent.dataset.loading = isLoading ? 'true' : 'false';
      this.sliderComponent.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    }

    if (isLoading) {
      if (this.card && this.card.dataset.swatchLoading === 'true') return;
      if (this._swatchLoadingShowTimer) return;
      this._swatchLoadingShowTimer = window.setTimeout(showOverlay, 200);
      return;
    }

    if (this._swatchLoadingShowTimer) {
      clearTimeout(this._swatchLoadingShowTimer);
      this._swatchLoadingShowTimer = null;
    }

    const clearOverlay = () => {
      this._swatchLoadingHideTimer = null;
      this._swatchLoadingVisibleAt = 0;
      if (this.card) {
        this.card.dataset.swatchLoading = 'false';
      }
    };

    if (!this.card || this.card.dataset.swatchLoading !== 'true') {
      clearOverlay();
      return;
    }

    const elapsed = Date.now() - this._swatchLoadingVisibleAt;
    const remaining = Math.max(0, 200 - elapsed);
    if (remaining === 0) {
      clearOverlay();
      return;
    }

    this._swatchLoadingHideTimer = window.setTimeout(clearOverlay, remaining);
  }

  syncSwatchSelectionState() {
    this.querySelectorAll('.product__swatch-radio--style').forEach((input) => {
      const selectedStyle = this.pendingStyle || this.currentStyle;
      const isCommitted = input.dataset.style === this.currentStyle;
      const isPending = !!this.pendingStyle && input.dataset.style === this.pendingStyle;
      const isSelected = input.dataset.style === selectedStyle;

      input.checked = isSelected;

      const swatch = input.closest('.product__swatch');
      if (swatch) {
        swatch.dataset.selected = isSelected ? 'true' : 'false';
        swatch.dataset.committed = isCommitted ? 'true' : 'false';
        swatch.dataset.pending = isPending ? 'true' : 'false';
      }
    });
  }

  beginPendingMobileStyleChange(style) {
    this.pendingStyle = style;
    this.syncSwatchSelectionState();
  }

  showMobileSwatchLoadingNow() {
    if (this._swatchLoadingShowTimer) {
      clearTimeout(this._swatchLoadingShowTimer);
      this._swatchLoadingShowTimer = null;
    }

    if (this._swatchLoadingHideTimer) {
      clearTimeout(this._swatchLoadingHideTimer);
      this._swatchLoadingHideTimer = null;
    }

    this._swatchLoadingVisibleAt = Date.now();
    if (this.card) {
      this.card.dataset.swatchLoading = 'true';
    }
    if (this.sliderComponent) {
      this.sliderComponent.dataset.loading = 'true';
      this.sliderComponent.setAttribute('aria-busy', 'true');
    }
  }

  failPendingMobileStyleChange(reason, error = null) {
    if (error) {
      console.error(`[card-swatches] Failed to load swatch for ${this.pendingStyle || this.currentStyle}: ${reason}`, error);
    } else {
      console.error(`[card-swatches] Failed to load swatch for ${this.pendingStyle || this.currentStyle}: ${reason}`);
    }

    this.showMobileSwatchLoadingNow();
    this.revertPendingMobileStyleChange();
    this.setMobileSwatchLoading(false);
  }

  ensureMobileCardReadyForSwatchChange() {
    if (window.innerWidth >= 750 || !this.viewAs || !this.card) return;
    if (this.card.dataset.mobileEnhanced === 'true') return;
    if (typeof this.viewAs._activateMobileCard !== 'function') return;

    this.viewAs._activateMobileCard(this.card);
  }

  syncStaticMediaFromSwatch(parent) {
    if (!parent) return;

    if (this.viewAs) {
      const productMedia = parent.querySelector(`template[data-media='variant-image']`);
      const modelMedia = parent.querySelector(`template[data-media='1']`);

      if (this.mediaProduct) {
        this.mediaProduct.innerHTML = '';
        if (productMedia) {
          this.mediaProduct.appendChild(productMedia.content.cloneNode(true));
        } else if (this.defaultMedia) {
          this.mediaProduct.appendChild(this.defaultMedia.content.cloneNode(true));
        }
      }

      if (this.mediaModel) {
        this.mediaModel.innerHTML = '';
        if (modelMedia) {
          this.mediaModel.appendChild(modelMedia.content.cloneNode(true));
        } else if (this.defaultMedia) {
          this.mediaModel.appendChild(this.defaultMedia.content.cloneNode(true));
        }

        const video = this.mediaModel.querySelector('video');
        this.ensureCardVideoAutoplay(video);
      }

      return;
    }

    if (!this.mediaContainer) return;

    let media = false;
    if (this.displayType == 'variant') {
      media = parent.querySelector(`template[data-media='variant-image']`);
    } else if (this.displayType == '0') {
      media = parent.querySelector(`template[data-media='0']`);
    } else if (this.displayType == '1') {
      media = parent.querySelector(`template[data-media='1']`);
    }

    if (!media) return;

    this.mediaContainer.innerHTML = '';
    this.mediaContainer.appendChild(media.content.cloneNode(true));
    const video = this.mediaContainer.querySelector('video');
    this.ensureCardVideoAutoplay(video);
  }

  commitMobileStyleChange(style, parent) {
    this.currentStyle = style;
    this.pendingStyle = null;
    this.syncSwatchSelectionState();

    if (parent && parent.querySelector('.product__swatch-price') && this.priceContainer) {
      this.priceContainer.innerHTML = parent.querySelector('.product__swatch-price').innerHTML;
    }

    if (this.link) {
      this.link.setAttribute('href', `/products/${this.currentStyle}`);
    }

    if (this.linkTitle) {
      this.linkTitle.setAttribute('href', `/products/${this.currentStyle}`);
    }

    const quickview = this.quickview;
    if (quickview) {
      quickview.setAttribute('data-product-handle', this.currentStyle);
      quickview.updateHandle();

      if (this.currentStyle == this.originalStyle) {
        quickview.classList.remove('hidden');
      } else {
        quickview.classList.add('hidden');

        if (window.innerWidth >= 990) {
          window.location.href = `/products/${this.currentStyle}`;
        }
      }
    }

    this.scheduleVisibleSwatchPrefetch();
  }

  revertPendingMobileStyleChange() {
    this.pendingStyle = null;
    this.syncSwatchSelectionState();

    if (this.priceContainer) {
      if (this.currentStyle === this.originalStyle) {
        this.priceContainer.innerHTML = this.originalPrice;
      }
    }

    if (this.link) {
      this.link.setAttribute('href', `/products/${this.currentStyle}`);
    }

    if (this.linkTitle) {
      this.linkTitle.setAttribute('href', `/products/${this.currentStyle}`);
    }

    const quickview = this.quickview;
    if (quickview) {
      quickview.setAttribute('data-product-handle', this.currentStyle);
      if (typeof quickview.updateHandle === 'function') quickview.updateHandle();
      quickview.classList.toggle('hidden', this.currentStyle !== this.originalStyle);
    }
  }

  primeMobileGalleryHero(heroImageUrl, mediaList) {
    const firstVisual =
      heroImageUrl ||
      (mediaList && mediaList.find((mediaItem) => mediaItem.media_type === 'image' && mediaItem.src)?.src) ||
      (mediaList && mediaList.find((mediaItem) => mediaItem.media_type === 'video' && mediaItem.poster)?.poster) ||
      '';

    if (!firstVisual) return Promise.resolve();

    return new Promise((resolve) => {
      const img = new Image();
      img.decoding = 'async';
      img.fetchPriority = 'high';
      img.onload = () => {
        if (typeof img.decode === 'function') {
          img.decode().catch(() => {}).finally(resolve);
          return;
        }
        resolve();
      };
      img.onerror = () => resolve();
      img.src = firstVisual;

      if (img.complete) {
        resolve();
      }
    });
  }

  getFirstVisualUrlFromMarkup(markup) {
    if (!markup) return '';

    const container = document.createElement('div');
    container.innerHTML = markup;

    const img = container.querySelector('img');
    if (img) {
      return img.currentSrc || img.getAttribute('src') || '';
    }

    const video = container.querySelector('video');
    if (video) {
      return video.getAttribute('poster') || '';
    }

    return '';
  }

  primeOriginalMobileState() {
    let firstVisualUrl = '';

    if (this.viewAs && this.viewAs.index === 0) {
      firstVisualUrl = this.getFirstVisualUrlFromMarkup(this.originalMediaProductHTML);
    } else if (this.viewAs && this.viewAs.index === 1) {
      firstVisualUrl = this.getFirstVisualUrlFromMarkup(this.originalMediaModelHTML);
    }

    if (!firstVisualUrl) {
      firstVisualUrl = this.getFirstVisualUrlFromMarkup(this._originalSliderHTML);
    }

    if (!firstVisualUrl) return Promise.resolve();
    return this.primeMobileGalleryHero(firstVisualUrl, []);
  }

  waitForMobileGalleryFirstVisual(firstVisual) {
    if (!firstVisual) return Promise.resolve();

    if (firstVisual.tagName === 'IMG') {
      return new Promise((resolve) => {
        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          resolve();
        };

        if (firstVisual.complete && firstVisual.naturalWidth > 0) {
          if (typeof firstVisual.decode === 'function') {
            firstVisual.decode().catch(() => {}).finally(finish);
            return;
          }
          finish();
          return;
        }

        const onDone = () => finish();
        firstVisual.addEventListener('load', onDone, { once: true });
        firstVisual.addEventListener('error', onDone, { once: true });
        window.setTimeout(finish, 1500);
      });
    }

    if (firstVisual.tagName === 'VIDEO') {
      const poster = firstVisual.getAttribute('poster');
      if (poster) {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve();
          img.onerror = () => resolve();
          img.src = poster;
          if (img.complete) resolve();
        });
      }

      return new Promise((resolve) => {
        let settled = false;
        const finish = () => {
          if (settled) return;
          settled = true;
          resolve();
        };
        const onDone = () => finish();
        firstVisual.addEventListener('loadeddata', onDone, { once: true });
        firstVisual.addEventListener('canplay', onDone, { once: true });
        window.setTimeout(finish, 800);
      });
    }

    return Promise.resolve();
  }

  async renderMobileGallery(sliderList, galleryId, mediaList, heroImageUrl) {
    if (!sliderList || !mediaList.length) return;

    const slidesFragment = document.createDocumentFragment();
    const videosToAutoplay = [];
    let firstVisual = null;

    if (heroImageUrl) {
      const heroSlide = document.createElement('li');
      heroSlide.id = `Slide-${galleryId}-gallery-hero`;
      heroSlide.className = 'content__item slider__slide mobile-swatch-slide';
      const heroWrap = document.createElement('div');
      heroWrap.className = 'media media--portrait media--hover-effect';
      const heroImg = document.createElement('img');
      heroImg.src = heroImageUrl;
      heroImg.alt = '';
      heroImg.decoding = 'async';
      heroImg.loading = 'eager';
      heroImg.fetchPriority = 'high';
      heroWrap.appendChild(heroImg);
      heroSlide.appendChild(heroWrap);
      slidesFragment.appendChild(heroSlide);
      firstVisual = heroImg;
    }

    mediaList.forEach((mediaItem, idx) => {
      const slide = document.createElement('li');
      slide.id = `Slide-${galleryId}-gallery-${idx}`;
      slide.className = 'content__item slider__slide mobile-swatch-slide';
      const wrap = document.createElement('div');
      wrap.className = 'media media--portrait media--hover-effect';

      if (mediaItem.media_type === 'video') {
        const video = document.createElement('video');
        video.setAttribute('playsinline', '');
        video.setAttribute('loop', '');
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.setAttribute('preload', 'metadata');
        if (mediaItem.poster) {
          video.setAttribute('poster', mediaItem.poster);
        }
        video.muted = true;
        mediaItem.sources.forEach((source) => {
          const src = document.createElement('source');
          src.src = source.url;
          src.type = source.mime_type;
          video.appendChild(src);
        });
        wrap.appendChild(video);
        videosToAutoplay.push(video);
        if (!firstVisual) firstVisual = video;
      } else {
        const img = document.createElement('img');
        img.src = mediaItem.src || '';
        img.alt = mediaItem.alt || '';
        img.decoding = 'async';
        img.loading = idx === 0 && !heroImageUrl ? 'eager' : 'lazy';
        if (idx === 0 && !heroImageUrl) {
          img.fetchPriority = 'high';
        }
        wrap.appendChild(img);
        if (!firstVisual) firstVisual = img;
      }

      slide.appendChild(wrap);
      slidesFragment.appendChild(slide);
    });

    const totalSlides = mediaList.length + (heroImageUrl ? 1 : 0);
    const controlWrapper = this.sliderComponent && this.sliderComponent.querySelector('.slideshow__control-wrapper');
    const dotsFragment = controlWrapper ? document.createDocumentFragment() : null;
    if (dotsFragment) {
      for (let i = 0; i < totalSlides; i++) {
        const dot = document.createElement('button');
        dot.className = 'slider-counter__link slider-counter__link--dots link';
        dot.setAttribute('aria-label', `${i + 1} of ${totalSlides}`);
        dot.setAttribute('aria-controls', sliderList.id);
        dotsFragment.appendChild(dot);
      }
    }

    await this.waitForMobileGalleryFirstVisual(firstVisual);

    sliderList.style.scrollBehavior = 'auto';
    sliderList.replaceChildren(...slidesFragment.childNodes);

    if (controlWrapper) {
      controlWrapper.replaceChildren(...dotsFragment.childNodes);
    }

    videosToAutoplay.forEach((video) => {
      this.ensureCardVideoAutoplay(video);
    });

    sliderList.scrollLeft = 0;
    if (this.sliderComponent && this.sliderComponent.dots !== undefined) {
      this.sliderComponent.dots = this.sliderComponent.querySelectorAll('.slider-counter__link');
    }
    if (this.sliderComponent && typeof this.sliderComponent.resetPages === 'function') {
      this.sliderComponent.resetPages();
    }
  }

  getLifestyleMediaItem(parent, swatchLifestyleMedia) {
    const lifestyleVideoTemplate = parent.querySelector(`template[data-media='lifestyle-video']`);
    if (lifestyleVideoTemplate) {
      const video = lifestyleVideoTemplate.content.querySelector('video');
      if (!video) return null;

      return {
        media_type: 'video',
        alt: '',
        poster: video.getAttribute('poster') || swatchLifestyleMedia || '',
        sources: Array.from(video.querySelectorAll('source')).map((source) => ({
          url: source.getAttribute('src') || '',
          mime_type: source.getAttribute('type') || ''
        })).filter((source) => source.url)
      };
    }

    if (!swatchLifestyleMedia) return null;

    return {
      media_type: 'image',
      src: swatchLifestyleMedia,
      alt: ''
    };
  }

  async renderMobileGalleryWithLeadingMedia(sliderList, galleryId, leadingMedia, mediaList, heroImageUrl) {
    if (!sliderList || !leadingMedia) return;

    const mergedMediaList = [leadingMedia];

    if (heroImageUrl) {
      mergedMediaList.push({
        media_type: 'image',
        src: heroImageUrl,
        alt: ''
      });
    }

    if (Array.isArray(mediaList) && mediaList.length) {
      mediaList.forEach((mediaItem) => {
        const candidateUrl =
          mediaItem.media_type === 'video'
            ? (mediaItem.poster || (mediaItem.sources && mediaItem.sources[0] && mediaItem.sources[0].url) || '')
            : (mediaItem.src || '');
        const leadingUrl =
          leadingMedia.media_type === 'video'
            ? (leadingMedia.poster || (leadingMedia.sources && leadingMedia.sources[0] && leadingMedia.sources[0].url) || '')
            : (leadingMedia.src || '');

        if (candidateUrl && leadingUrl && candidateUrl === leadingUrl) return;
        if (heroImageUrl && mediaItem.media_type === 'image' && mediaItem.src === heroImageUrl) return;

        mergedMediaList.push(mediaItem);
      });
    }

    return this.renderMobileGallery(sliderList, galleryId, mergedMediaList, null);
  }

  async renderMobileSingleMedia(sliderList, galleryId, mediaMarkup) {
    if (!sliderList || !mediaMarkup) return;

    const slide = document.createElement('li');
    slide.id = `Slide-${galleryId}-single-0`;
    slide.className = 'content__item slider__slide mobile-swatch-slide';

    const wrap = document.createElement('div');
    wrap.className = 'media media--portrait media--hover-effect';

    if (typeof mediaMarkup === 'string') {
      wrap.innerHTML = mediaMarkup;
    } else {
      wrap.appendChild(mediaMarkup.cloneNode(true));
    }

    slide.appendChild(wrap);

    const firstVisual = wrap.querySelector('img, video');
    await this.waitForMobileGalleryFirstVisual(firstVisual);

    sliderList.style.scrollBehavior = 'auto';
    sliderList.replaceChildren(slide);

    const controlWrapper = this.sliderComponent && this.sliderComponent.querySelector('.slideshow__control-wrapper');
    if (controlWrapper) {
      const dot = document.createElement('button');
      dot.className = 'slider-counter__link slider-counter__link--dots link';
      dot.setAttribute('aria-label', '1 of 1');
      dot.setAttribute('aria-controls', sliderList.id);
      controlWrapper.replaceChildren(dot);
    }

    const video = wrap.querySelector('video');
    this.ensureCardVideoAutoplay(video);

    sliderList.scrollLeft = 0;
    if (this.sliderComponent && this.sliderComponent.dots !== undefined) {
      this.sliderComponent.dots = this.sliderComponent.querySelectorAll('.slider-counter__link');
    }
    if (this.sliderComponent && typeof this.sliderComponent.resetPages === 'function') {
      this.sliderComponent.resetPages();
    }
  }

  onSwatchPointerDown(e) {
    const label = e.target.closest('.product__swatch-label--style');
    if (!label || label.closest('.product__swatch--more')) return;
    if (!this.contains(label)) return;

    const input = label.control || label.previousElementSibling;
    if (!input || !input.dataset.style || input.dataset.style === this.currentStyle) return;
    if (!this.contains(input)) return;

    this.ensureMobileCardReadyForSwatchChange();
    this.prefetchMobileGallery(input.dataset.style);

    if (this._swatchPointerFallbackTimer) {
      clearTimeout(this._swatchPointerFallbackTimer);
    }

    const requestedStyle = input.dataset.style;
    this._swatchPointerFallbackTimer = window.setTimeout(() => {
      this._swatchPointerFallbackTimer = null;
      this.triggerSwatchChangeFallback(input, requestedStyle);
    }, 180);
  }

  onSwatchClick(e) {
    const label = e.target.closest('.product__swatch-label--style');
    if (!label || label.closest('.product__swatch--more')) return;
    if (!this.contains(label)) return;

    const input = label.control || label.previousElementSibling;
    if (!input || !input.dataset.style || input.dataset.style === this.currentStyle) return;
    if (!this.contains(input)) return;

    if (window.innerWidth >= 750) return;

    e.preventDefault();
    e.stopPropagation();

    if (this._swatchPointerFallbackTimer) {
      clearTimeout(this._swatchPointerFallbackTimer);
      this._swatchPointerFallbackTimer = null;
    }
    if (this._swatchClickFallbackTimer) {
      clearTimeout(this._swatchClickFallbackTimer);
      this._swatchClickFallbackTimer = null;
    }

    const requestedStyle = input.dataset.style;
    if (
      this.pendingStyle === requestedStyle &&
      this._lastManualSwatchSelectionStyle === requestedStyle &&
      Date.now() - this._lastManualSwatchSelectionAt < 500
    ) {
      return;
    }

    this._lastManualSwatchSelectionStyle = requestedStyle;
    this._lastManualSwatchSelectionAt = Date.now();
    input.checked = true;
    this.onVariantChange({ target: input });
  }

  triggerSwatchChangeFallback(input, requestedStyle) {
    if (!this.isConnected || !input) return;
    if (this.currentStyle === requestedStyle) return;

    const nativeChangeHandled =
      this._lastVariantChangeStyle === requestedStyle && Date.now() - this._lastVariantChangeAt < 500;

    if (nativeChangeHandled) return;

    input.checked = true;
    this.onVariantChange({ target: input });
  }

  init() {
    if (this._initStarted) return;
    this._initStarted = true;

    const cachedSwatches = this.getCachedSwatchList();
    if (cachedSwatches) {
      this.renderSwatchList(cachedSwatches);
      this.scheduleVisibleSwatchPrefetch();
      return;
    }

    this.fetchSwatchList()
      .then((swatchList) => {
        this.renderSwatchList(swatchList);
        this.scheduleVisibleSwatchPrefetch();
      })
      .catch(() => {
        this._initStarted = false;
        this.dataset.swatchesLoading = 'false';
        this.dataset.swatchesReady = 'false';
      });
  }

  _resetMobileSlider() {
    this._mobileGalleryRequestId++;
    this.pendingStyle = null;
    this.cancelVisibleSwatchPrefetch();
    this.setMobileSwatchLoading(false);
    const sliderList = this.link && this.link.querySelector('[id^="Slider-"]');
    const controlWrapper = this.sliderComponent && this.sliderComponent.querySelector('.slideshow__control-wrapper');
    if (sliderList && this._originalSliderHTML !== null) {
      sliderList.style.scrollBehavior = 'auto';
      sliderList.innerHTML = this._originalSliderHTML;
      // Restore original dot count alongside original slides
      if (controlWrapper && this._originalDotsHTML !== null) {
        controlWrapper.innerHTML = this._originalDotsHTML;
      }
      // Re-inject the desktop static image as slide 0 to restore the default state.
      // Restore originalMediaProductHTML / originalMediaModelHTML first so that
      // lifestyle media (which may have been overwritten by a swatch switch) is
      // included in the cloned hero slide.
      const productId = sliderList.id.replace('Slider-', '');
      if (this.viewAs && this.viewAs.index === 0) {
        const productMedia = this.link && this.link.querySelector('.media--product');
        if (productMedia) {
          if (this.originalMediaProductHTML !== null) {
            productMedia.innerHTML = this.originalMediaProductHTML;
          }
          const slide = document.createElement('li');
          slide.id = `Slide-${productId}-0`;
          slide.className = 'content__item slider__slide mobile-product-hero-slide';
          const wrap = document.createElement('div');
          wrap.className = productMedia.className.replace('hidden', '').trim();
          wrap.innerHTML = productMedia.innerHTML.replace(/loading="lazy"/gi, 'loading="eager"');
          slide.appendChild(wrap);
          sliderList.prepend(slide);
          const heroVideo = slide.querySelector('video');
          if (heroVideo) this.ensureCardVideoAutoplay(heroVideo);
          // Add a matching dot for the injected hero slide
          if (controlWrapper) {
            const dot = document.createElement('button');
            dot.className = 'slider-counter__link slider-counter__link--dots link mobile-hero-dot';
            dot.setAttribute('aria-controls', sliderList.id);
            controlWrapper.prepend(dot);
          }
        }
      } else if (this.viewAs && this.viewAs.index === 1) {
        // Inject model hero if media[1] wasn't in the original Liquid, OR if lifestyle
        // media is active — matching ViewAsToggle.load() behaviour.
        const modelMedia = this.link && this.link.querySelector('.media--model');
        const hasLifestyleMedia = modelMedia && modelMedia.dataset.hasLifestyleMedia === 'true';
        const firstLiquidSlide = sliderList.querySelector(`#Slide-${productId}-2`);
        if (!firstLiquidSlide || hasLifestyleMedia) {
          if (modelMedia) {
            if (this.originalMediaModelHTML !== null) {
              modelMedia.innerHTML = this.originalMediaModelHTML;
            }
            const slide = document.createElement('li');
            slide.id = `Slide-${productId}-0`;
            slide.className = 'content__item slider__slide mobile-model-hero-slide';
            const wrap = document.createElement('div');
            wrap.className = modelMedia.className.replace('hidden', '').trim();
            wrap.innerHTML = modelMedia.innerHTML.replace(/loading="lazy"/gi, 'loading="eager"');
            slide.appendChild(wrap);
            sliderList.prepend(slide);
            const heroVideo = slide.querySelector('video');
            if (heroVideo) this.ensureCardVideoAutoplay(heroVideo);
            if (controlWrapper) {
              const dot = document.createElement('button');
              dot.className = 'slider-counter__link slider-counter__link--dots link mobile-hero-dot';
              dot.setAttribute('aria-controls', sliderList.id);
              controlWrapper.prepend(dot);
            }
          }
        }
      }
      sliderList.scrollLeft = 0;
      // Refresh cached dots reference before resetPages/update runs
      if (this.sliderComponent && this.sliderComponent.dots !== undefined) {
        this.sliderComponent.dots = this.sliderComponent.querySelectorAll('.slider-counter__link');
      }
      if (this.sliderComponent && typeof this.sliderComponent.resetPages === 'function') {
        this.sliderComponent.resetPages();
      }
    } else if (!sliderList && this.card && this.card.classList.contains('card--simple')) {
      // Simple cards have no slider id — restore original static media directly
      if (this.mediaProduct && this.originalMediaProductHTML !== null) {
        this.mediaProduct.innerHTML = this.originalMediaProductHTML;
      }
      if (this.mediaModel && this.originalMediaModelHTML !== null) {
        this.mediaModel.innerHTML = this.originalMediaModelHTML;
      }
    }
    // Restore swatch selection, price, and links to the original product
    if (this.currentStyle !== this.originalStyle) {
      this.currentStyle = this.originalStyle;
      if (this.priceContainer) this.priceContainer.innerHTML = this.originalPrice;
      if (this.link) this.link.setAttribute('href', `/products/${this.originalStyle}`);
      if (this.linkTitle) this.linkTitle.setAttribute('href', `/products/${this.originalStyle}`);
      const quickview = this.quickview;
      if (quickview) {
        quickview.setAttribute('data-product-handle', this.originalStyle);
        if (typeof quickview.updateHandle === 'function') quickview.updateHandle();
        quickview.classList.remove('hidden');
      }
    }

    this.syncSwatchSelectionState();
  }

  onCardEnter() {
    this._cardEntered = true;
    if (!this.viewAs) return;

    const sliderList = this.link && this.link.querySelector('[id^="Slider-"]');

    if (this.viewAs.index === 0) {
      // PRODUCT mode: hide off-model static, reveal slider scrolled past off-model slide 1
      if (this.sliderComponent) {
        this.sliderComponent.classList.remove('scroll-trigger', 'animate--slide-in');
        this.sliderComponent.classList.remove('hidden');
      }
      if (this.mediaProduct) this.mediaProduct.classList.add('hidden');
      // Slider only contains on-model images — start at position 0 (slide 1 = first on-model)
      if (sliderList) {
        sliderList.style.scrollBehavior = 'auto';
        sliderList.scrollLeft = 0;
      }
      // Re-measure now that slider is visible — sliderItemsToShow was empty while hidden.
      if (this.sliderComponent && typeof this.sliderComponent.resetPages === 'function') {
        requestAnimationFrame(() => this.sliderComponent.resetPages());
      }
      // Play any videos in the revealed slider (autoplay doesn't fire from display:none).
      if (this.sliderComponent) {
        this.sliderComponent.querySelectorAll('video').forEach((v) => this.ensureCardVideoAutoplay(v));
      }
    } else if (this.viewAs.index === 1) {
      // MODEL mode: inject off-model as slide 0, hide dots, show slider with arrows
      if (sliderList) {
        // Remove any previously injected slide (prevents duplication on quick re-hover)
        const prev = sliderList.querySelector('.model-off-model-slide');
        if (prev) prev.remove();

        // Clone off-model image from .media--product and inject as slide 0
        if (this.mediaProduct) {
          const slide = document.createElement('li');
          slide.id = 'Slide-model-off';
          slide.className = 'content__item slider__slide model-off-model-slide';
          const wrap = document.createElement('div');
          wrap.className = this.mediaProduct.className.replace('hidden', '').trim();
          wrap.innerHTML = this.mediaProduct.innerHTML;
          slide.appendChild(wrap);
          sliderList.prepend(slide);
        }

        sliderList.style.scrollBehavior = 'auto';
        sliderList.scrollLeft = 0;
      }

      // Hide dots at slide 0 (off-model); show them when user arrows into on-model gallery.
      // SliderComponent.update() runs first on scroll and sets currentPage based on absolute scrollLeft,
      // counting the injected slide as page 1. We correct by re-applying dot activation at currentPage - 2
      // (−1 for 0-indexing, −1 for the injected slide offset).
      if (this.controlWrapper) this.controlWrapper.classList.add('hidden');
      this._modelScrollListener = () => {
        if (!this.controlWrapper) return;
        const sliderComp = this.sliderComponent;
        if (sliderList.scrollLeft > 5) {
          this.controlWrapper.classList.remove('hidden');
          if (sliderComp && sliderComp.dots && sliderComp.currentPage) {
            sliderComp.dots.forEach((d) => d.classList.remove('slider-counter__link--active'));
            const correctDotIndex = sliderComp.currentPage - 2;
            if (sliderComp.dots[correctDotIndex]) {
              sliderComp.dots[correctDotIndex].classList.add('slider-counter__link--active');
            }
          }
        } else {
          this.controlWrapper.classList.add('hidden');
        }
      };
      sliderList.addEventListener('scroll', this._modelScrollListener);

      if (this.sliderComponent) {
        this.sliderComponent.classList.remove('scroll-trigger', 'animate--slide-in');
        this.sliderComponent.classList.remove('hidden');
        // Re-measure so sliderItemsToShow is populated and prev/next buttons work.
        if (typeof this.sliderComponent.resetPages === 'function') {
          requestAnimationFrame(() => this.sliderComponent.resetPages());
        }
        // Play any videos in the revealed slider (autoplay doesn't fire from display:none).
        this.sliderComponent.querySelectorAll('video').forEach((v) => this.ensureCardVideoAutoplay(v));
      }
      if (this.mediaModel) this.mediaModel.classList.add('hidden');
    }
  }

  onCardLeave() {
    this._cardEntered = false;
    if (!this.viewAs) return;

    const sliderList = this.link && this.link.querySelector('[id^="Slider-"]');

    // Reset slider scroll instantly before hiding (prevents initPages() re-animation on next show)
    if (sliderList) {
      sliderList.style.scrollBehavior = 'auto';
      sliderList.scrollLeft = 0;
    }

    if (this.sliderComponent) this.sliderComponent.classList.add('hidden');

    if (this.viewAs.index === 0) {
      // PRODUCT mode: restore off-model static image (original Liquid-rendered HTML, preserves lifestyle overrides)
      if (this.mediaProduct) {
        if (this.originalMediaProductHTML !== null) {
          this.mediaProduct.innerHTML = this.originalMediaProductHTML;
        }
        this.mediaProduct.classList.remove('hidden');
        const restoredVideo = this.mediaProduct.querySelector('video');
        if (restoredVideo) this.ensureCardVideoAutoplay(restoredVideo);
      }
      if (this.priceContainer) this.priceContainer.innerHTML = this.originalPrice;
    } else if (this.viewAs.index === 1) {
      // MODEL mode: remove injected off-model slide and restore dots before restoring static
      if (sliderList && this._modelScrollListener) {
        sliderList.removeEventListener('scroll', this._modelScrollListener);
        this._modelScrollListener = null;
      }
      if (sliderList) {
        const injected = sliderList.querySelector('.model-off-model-slide');
        if (injected) injected.remove();
      }
      if (this.controlWrapper) this.controlWrapper.classList.remove('hidden');

      if (this.mediaProduct) this.mediaProduct.classList.add('hidden');
      if (this.mediaModel) {
        if (this.originalMediaModelHTML !== null) {
          this.mediaModel.innerHTML = this.originalMediaModelHTML;
        }
        this.mediaModel.classList.remove('hidden');
        const restoredVideo = this.mediaModel.querySelector('video');
        if (restoredVideo) this.ensureCardVideoAutoplay(restoredVideo);
      }
      if (this.priceContainer) this.priceContainer.innerHTML = this.originalPrice;
    }
  }

  onVariantChange(e) {
    const input = e.target;
    if (!input || !this.contains(input)) return;

    const parent = input.closest('.product__swatch');
    if (!parent || !this.contains(parent)) return;

    const requestedStyle = input.dataset.style;
    this._lastVariantChangeStyle = requestedStyle;
    this._lastVariantChangeAt = Date.now();

    if (this._swatchPointerFallbackTimer) {
      clearTimeout(this._swatchPointerFallbackTimer);
      this._swatchPointerFallbackTimer = null;
    }
    if (this._swatchClickFallbackTimer) {
      clearTimeout(this._swatchClickFallbackTimer);
      this._swatchClickFallbackTimer = null;
    }

    this.setAttribute('data-interact', true);

    if (window.innerWidth >= 750) {
      this.currentStyle = requestedStyle;
      window.location.href = `/products/${this.currentStyle}`;
    } else {
      this.ensureMobileCardReadyForSwatchChange();
      const mobileGalleryRequestId = ++this._mobileGalleryRequestId;
      this.beginPendingMobileStyleChange(requestedStyle);
      this.setMobileSwatchLoading(true);
      // Get the current collection ID for checking lifestyle collections
      var currentCollectionId = this.dataset.collectionId;
      
      // Check if the clicked swatch has lifestyle content media and if current collection is in its lifestyle collections
      var swatchLifestyleMedia = parent.dataset.lifestyleContentMedia;
      var swatchLifestyleCollections = parent.dataset.lifestyleContentCollections;
      var shouldUseSwatchLifestyleMedia = false;
      
      if (swatchLifestyleMedia && swatchLifestyleCollections && currentCollectionId) {
        var lifestyleCollectionIds = swatchLifestyleCollections.split(',');
        shouldUseSwatchLifestyleMedia = lifestyleCollectionIds.includes(currentCollectionId);
      }

      if (requestedStyle === this.originalStyle) {
        this.primeOriginalMobileState().then(() => {
          if (mobileGalleryRequestId !== this._mobileGalleryRequestId) return;
          this._resetMobileSlider();
        });
        return;
      }
      
      // Check if this swatch represents the current product and if we should use current product's lifestyle media
      var swatchHandle = parent.dataset.handle;
      var currentProductHandle = this.originalStyle;
      var isCurrentProductSwatch = swatchHandle === currentProductHandle;
      var isCurrentSwatchChecked = input && input.checked;
      var shouldUseCurrentProductLifestyleMedia = this.dataset.imageOverride && this.dataset.inLifestyleCollection == 'true' && isCurrentProductSwatch && isCurrentSwatchChecked;
      
      if (shouldUseSwatchLifestyleMedia) {
        // Use lifestyle content media for mobile when clicking on swatch with lifestyle media
        var lifestyleVideoTemplate = parent.querySelector(`template[data-media='lifestyle-video']`);
        var lifestyleMarkup = lifestyleVideoTemplate ? lifestyleVideoTemplate.innerHTML : `<img src="${swatchLifestyleMedia}" alt="" class="motion-reduce" loading="eager" fetchpriority="high">`;
        const lifestyleMediaItem = this.getLifestyleMediaItem(parent, swatchLifestyleMedia);

        if (window.innerWidth < 750) {
          const lifestyleSliderList = this.link && this.link.querySelector('[id^="Slider-"]');
          const lifestyleGalleryId = lifestyleSliderList ? lifestyleSliderList.id.replace('Slider-', '') : '';
          const isProductView = this.viewAs && this.viewAs.index === 0;
          const lifestyleVariantImage = isProductView ? (parent.dataset.variantImage || parent.dataset.image0) : null;

          this.getMobileGallery(swatchHandle)
            .then((mediaList) => {
              if (mobileGalleryRequestId !== this._mobileGalleryRequestId) return;
              if (!lifestyleSliderList || !lifestyleMediaItem) {
                this.failPendingMobileStyleChange('missing lifestyle media');
                return;
              }

              return this.renderMobileGalleryWithLeadingMedia(
                lifestyleSliderList,
                lifestyleGalleryId,
                lifestyleMediaItem,
                mediaList,
                lifestyleVariantImage
              );
            })
            .then(() => {
              if (mobileGalleryRequestId !== this._mobileGalleryRequestId) return;
              if (!lifestyleSliderList) return;

              if (this.viewAs) {
                if (this.mediaProduct) this.mediaProduct.innerHTML = lifestyleMarkup;
                if (this.mediaModel) this.mediaModel.innerHTML = lifestyleMarkup;
                const productVideo = this.mediaProduct && this.mediaProduct.querySelector('video');
                const modelVideo = this.mediaModel && this.mediaModel.querySelector('video');
                this.ensureCardVideoAutoplay(productVideo);
                this.ensureCardVideoAutoplay(modelVideo);
              } else if (this.mediaContainer) {
                this.mediaContainer.innerHTML = lifestyleMarkup;
                var video = this.mediaContainer.querySelector('video');
                if (video) this.ensureCardVideoAutoplay(video);
              }

              this.commitMobileStyleChange(requestedStyle, parent);
              this.setMobileSwatchLoading(false);
            })
            .catch((error) => {
              if (mobileGalleryRequestId !== this._mobileGalleryRequestId) return;
              this.failPendingMobileStyleChange('rendering lifestyle media failed', error);
            });
        } else {
          if (this.viewAs) {
            this.mediaProduct.innerHTML = lifestyleMarkup;
            this.mediaModel.innerHTML = lifestyleMarkup;
            var productVideo = this.mediaProduct.querySelector('video');
            var modelVideo = this.mediaModel.querySelector('video');
            this.ensureCardVideoAutoplay(productVideo);
            this.ensureCardVideoAutoplay(modelVideo);
          } else if (this.mediaContainer) {
            this.mediaContainer.innerHTML = lifestyleMarkup;
            var video = this.mediaContainer.querySelector('video');
            if (video) {
              this.ensureCardVideoAutoplay(video);
            }
          }
          if (mobileGalleryRequestId === this._mobileGalleryRequestId) {
            this.commitMobileStyleChange(requestedStyle, parent);
            this.setMobileSwatchLoading(false);
          }
        }
      } else if (shouldUseCurrentProductLifestyleMedia) {
        // Restore lifestyle content media for mobile when clicking on current product's swatch
        if (this.viewAs) {
          if (this.lifestyleMediaProductHTML) {
            this.mediaProduct.innerHTML = this.lifestyleMediaProductHTML;
            this.ensureCardVideoAutoplay(this.mediaProduct.querySelector('video'));
          }
          if (this.lifestyleMediaModelHTML) {
            this.mediaModel.innerHTML = this.lifestyleMediaModelHTML;
            this.ensureCardVideoAutoplay(this.mediaModel.querySelector('video'));
          }
        } else if (this.mediaContainer) {
          if (this.lifestyleMediaHTML) {
            this.mediaContainer.innerHTML = this.lifestyleMediaHTML;
            this.ensureCardVideoAutoplay(this.mediaContainer.querySelector('video'));
          }
        }
        if (mobileGalleryRequestId === this._mobileGalleryRequestId) {
          this.commitMobileStyleChange(requestedStyle, parent);
          this.setMobileSwatchLoading(false);
        }
      } else {
        // Use the original logic for regular media (other product swatches or non-lifestyle products)
        if (this.viewAs) {
          if (window.innerWidth < 750) {
            // MOBILE: load swatch product's full gallery into slider
            const sliderList = this.link && this.link.querySelector('[id^="Slider-"]');

            // Simple cards (e.g. search page) have no slider id — update static media directly
            if (!sliderList && this.card && this.card.classList.contains('card--simple')) {
              this.syncStaticMediaFromSwatch(parent);
              this.commitMobileStyleChange(requestedStyle, parent);
              this.setMobileSwatchLoading(false);
            } else {

            const galleryProductId = sliderList ? sliderList.id.replace('Slider-', '') : '';
            const isProductView = this.viewAs && this.viewAs.index === 0;
            const variantImageUrl = isProductView ? (parent.dataset.variantImage || parent.dataset.image0) : null;

            this.getMobileGallery(swatchHandle)
              .then((mediaList) => {
                if (mobileGalleryRequestId !== this._mobileGalleryRequestId) return;
                if (!sliderList || !mediaList.length) {
                  this.failPendingMobileStyleChange('missing mobile gallery media');
                  return;
                }

                return this.primeMobileGalleryHero(variantImageUrl, mediaList).then(() => {
                  if (mobileGalleryRequestId !== this._mobileGalleryRequestId || !sliderList) {
                    if (mobileGalleryRequestId === this._mobileGalleryRequestId) {
                      this.failPendingMobileStyleChange('mobile slider unavailable before render');
                    }
                    return;
                  }
                  return this.renderMobileGallery(sliderList, galleryProductId, mediaList, variantImageUrl)
                    .then(() => {
                      if (mobileGalleryRequestId !== this._mobileGalleryRequestId || !sliderList) return;
                      this.syncStaticMediaFromSwatch(parent);
                      this.commitMobileStyleChange(requestedStyle, parent);
                      this.setMobileSwatchLoading(false);
                    })
                    .catch((error) => {
                      if (mobileGalleryRequestId !== this._mobileGalleryRequestId) return;
                      this.failPendingMobileStyleChange('rendering mobile gallery failed', error);
                    });
                });
              })
              .catch((error) => {
                if (mobileGalleryRequestId !== this._mobileGalleryRequestId) return;
                this.failPendingMobileStyleChange('mobile gallery request failed', error);
              });

            } // end else (slider exists)

          } else {
            // DESKTOP: update mediaProduct/mediaModel HTML content
            var productMedia = parent.querySelector(`template[data-media='variant-image']`);
            var modelMedia = parent.querySelector(`template[data-media='1']`);

            if (productMedia) {
              this.mediaProduct.innerHTML = '';
              this.mediaProduct.appendChild(productMedia.content.cloneNode(true));
            } else {
              this.mediaProduct.innerHTML = '';
              this.mediaProduct.appendChild(this.defaultMedia.content.cloneNode(true));
            }

            if (modelMedia) {
              this.mediaModel.innerHTML = '';
              this.mediaModel.appendChild(modelMedia.content.cloneNode(true));
            } else {
              this.mediaModel.innerHTML = '';
              this.mediaModel.appendChild(this.defaultMedia.content.cloneNode(true));
            }

            var video = this.mediaModel.querySelector('video');
            this.ensureCardVideoAutoplay(video);
          }
        } else {
          // No-toggle mobile: fetch the swatch product's gallery into the slider
          const noToggleSliderList = this.link && this.link.querySelector('[id^="Slider-"]');
          if (noToggleSliderList) {
            const noToggleGalleryId = noToggleSliderList.id.replace('Slider-', '');
            const noToggleVariantImage = parent.dataset.variantImage || parent.dataset.image0;
            this.getMobileGallery(swatchHandle)
              .then((mediaList) => {
                if (mobileGalleryRequestId !== this._mobileGalleryRequestId) return;
                if (!noToggleSliderList || !mediaList.length) {
                  this.failPendingMobileStyleChange('missing no-toggle gallery media');
                  return;
                }

                return this.primeMobileGalleryHero(noToggleVariantImage, mediaList).then(() => {
                  if (mobileGalleryRequestId !== this._mobileGalleryRequestId || !noToggleSliderList) {
                    if (mobileGalleryRequestId === this._mobileGalleryRequestId) {
                      this.failPendingMobileStyleChange('no-toggle slider unavailable before render');
                    }
                    return;
                  }
                  return this.renderMobileGallery(noToggleSliderList, noToggleGalleryId, mediaList, noToggleVariantImage)
                    .then(() => {
                      if (mobileGalleryRequestId !== this._mobileGalleryRequestId || !noToggleSliderList) return;
                      this.syncStaticMediaFromSwatch(parent);
                      this.commitMobileStyleChange(requestedStyle, parent);
                      this.setMobileSwatchLoading(false);
                    })
                    .catch((error) => {
                      if (mobileGalleryRequestId !== this._mobileGalleryRequestId) return;
                      this.failPendingMobileStyleChange('rendering no-toggle gallery failed', error);
                    });
                });
              })
              .catch((error) => {
                if (mobileGalleryRequestId !== this._mobileGalleryRequestId) return;
                this.failPendingMobileStyleChange('no-toggle gallery request failed', error);
              });
          } else {
            var media = false;
            if (this.displayType == 'variant') {
              media = parent.querySelector(`template[data-media='variant-image']`);
            } else if (this.displayType == '0') {
              media = parent.querySelector(`template[data-media='0']`);
            } else if (this.displayType == '1') {
              media = parent.querySelector(`template[data-media='1']`);
            }
            if (media) {
              this.mediaContainer.innerHTML = '';
              this.mediaContainer.appendChild(media.content.cloneNode(true));
              var video = this.mediaContainer.querySelector('video');
              this.ensureCardVideoAutoplay(video);
              this.commitMobileStyleChange(requestedStyle, parent);
            } else {
              this.failPendingMobileStyleChange('missing fallback media template');
            }
            this.setMobileSwatchLoading(false);
          }
        }
      }
    }
  }

  onMouseOver(e) {
    var target = e.target.closest('.product__swatch');

    if (target && target.classList.contains('product__swatch')) {
      this._swatchHovered = true;
      var media = false;
      
      // Get the current collection ID for checking lifestyle collections
      var currentCollectionId = this.dataset.collectionId;
      
      // Check if the hovered swatch has lifestyle content media and if current collection is in its lifestyle collections
      var swatchLifestyleMedia = target.dataset.lifestyleContentMedia;
      var swatchLifestyleCollections = target.dataset.lifestyleContentCollections;
      var shouldUseSwatchLifestyleMedia = false;
      
      if (swatchLifestyleMedia && swatchLifestyleCollections && currentCollectionId) {
        var lifestyleCollectionIds = swatchLifestyleCollections.split(',');
        shouldUseSwatchLifestyleMedia = lifestyleCollectionIds.includes(currentCollectionId);
      }
      
      // Check if this swatch represents the current product and if we should use current product's lifestyle media
      var swatchHandle = target.dataset.handle;
      var currentProductHandle = this.originalStyle;
      var isCurrentProductSwatch = swatchHandle === currentProductHandle;
      var shouldUseCurrentProductLifestyleMedia = this.dataset.imageOverride && this.dataset.inLifestyleCollection == 'true' && isCurrentProductSwatch;

      // PRODUCT mode: primary swatch hover = no action, restore off-model view
      if (this.viewAs && this.viewAs.index === 0 && isCurrentProductSwatch) {
        if (this.sliderComponent) this.sliderComponent.classList.add('hidden');
        if (this.mediaProduct) {
          if (shouldUseCurrentProductLifestyleMedia && this.lifestyleMediaProductHTML) {
            this.mediaProduct.innerHTML = this.lifestyleMediaProductHTML;
            this.ensureCardVideoAutoplay(this.mediaProduct.querySelector('video'));
          }
          this.mediaProduct.classList.remove('hidden');
        }
        return;
      }

      // MODEL mode: primary swatch hover = no action (off-model slider view stays)
      if (this.viewAs && this.viewAs.index === 1 && isCurrentProductSwatch) {
        if (shouldUseCurrentProductLifestyleMedia && this.lifestyleMediaModelHTML) {
          this.mediaModel.innerHTML = this.lifestyleMediaModelHTML;
          this.ensureCardVideoAutoplay(this.mediaModel.querySelector('video'));
        }
        return;
      }

      if (shouldUseSwatchLifestyleMedia) {
        // Use lifestyle content media for the swatch being hovered over
        if (this.viewAs) {
          var lifestyleVideoTemplate = target.querySelector(`template[data-media='lifestyle-video']`);
          if (lifestyleVideoTemplate) {
            this.mediaProduct.innerHTML = '';
            this.mediaProduct.appendChild(lifestyleVideoTemplate.content.cloneNode(true));
            
            this.mediaModel.innerHTML = '';
            this.mediaModel.appendChild(lifestyleVideoTemplate.content.cloneNode(true));

            var video = this.mediaModel.querySelector('video');
            if (video) {
              video.play();
            }
          } else {
            var lifestyleTemplate = document.createElement('template');
            lifestyleTemplate.innerHTML = `<img src="${swatchLifestyleMedia}" alt="" class="motion-reduce" loading="lazy">`;
            
            this.mediaProduct.innerHTML = '';
            this.mediaProduct.appendChild(lifestyleTemplate.content.cloneNode(true));
            
            this.mediaModel.innerHTML = '';
            this.mediaModel.appendChild(lifestyleTemplate.content.cloneNode(true));
          }
        } else if (this.mediaContainer) {
          var lifestyleVideoTemplate = target.querySelector(`template[data-media='lifestyle-video']`);
          if (lifestyleVideoTemplate) {
            this.mediaContainer.innerHTML = '';
            this.mediaContainer.appendChild(lifestyleVideoTemplate.content.cloneNode(true));
            var video = this.mediaContainer.querySelector('video');
            if (video) {
              video.play();
            }
          } else {
            var lifestyleTemplate = document.createElement('template');
            lifestyleTemplate.innerHTML = `<img src="${swatchLifestyleMedia}" alt="" class="motion-reduce" loading="lazy">`;
            
            this.mediaContainer.innerHTML = '';
            this.mediaContainer.appendChild(lifestyleTemplate.content.cloneNode(true));
          }
        }
      } else if (shouldUseCurrentProductLifestyleMedia) {
        // Restore lifestyle content media only for the current product's swatch
        if (this.viewAs) {
          if (this.lifestyleMediaProductHTML) this.mediaProduct.innerHTML = this.lifestyleMediaProductHTML;
          if (this.lifestyleMediaModelHTML) this.mediaModel.innerHTML = this.lifestyleMediaModelHTML;
        } else if (this.mediaContainer) {
          var lifestyleVideoTemplate = target.querySelector(`template[data-media='lifestyle-video']`);
          if (lifestyleVideoTemplate) {
            this.mediaContainer.innerHTML = '';
            this.mediaContainer.appendChild(lifestyleVideoTemplate.content.cloneNode(true));
            var video = this.mediaContainer.querySelector('video');
            if (video) {
              video.play();
            }
          } else {
            if (this.lifestyleMediaHTML) {
              this.mediaContainer.innerHTML = this.lifestyleMediaHTML;
              this.ensureCardVideoAutoplay(this.mediaContainer.querySelector('video'));
            }
          }
        }
      } else {
        // Use the original logic for regular media (other product swatches or non-lifestyle products)
        if (this.viewAs && !target.classList.contains('product__swatch--more')) {
          var productMedia = target.querySelector(`template[data-media='variant-image']`);
          var modelMedia = target.querySelector(`template[data-media='1']`);

          if (productMedia) {
            this.mediaProduct.innerHTML = '';
            this.mediaProduct.appendChild(productMedia.content.cloneNode(true));
          } else {
            this.mediaProduct.innerHTML = '';
            this.mediaProduct.appendChild(this.defaultMedia.content.cloneNode(true));
          }

          if (modelMedia) {
            this.mediaModel.innerHTML = '';
            this.mediaModel.appendChild(modelMedia.content.cloneNode(true));
          } else {
            this.mediaModel.innerHTML = '';
            this.mediaModel.appendChild(this.defaultMedia.content.cloneNode(true));
          }

          var video = this.mediaModel.querySelector('video');
          this.ensureCardVideoAutoplay(video);

          // Update visibility based on current view mode
          if (this.viewAs.index === 0) {
            // PRODUCT mode: show off-model static image, hide slider
            if (this.sliderComponent) this.sliderComponent.classList.add('hidden');
            if (this.mediaProduct) this.mediaProduct.classList.remove('hidden');
          } else if (this.viewAs.index === 1) {
            // MODEL mode: show on-model variant image, hide slider
            if (this.sliderComponent) this.sliderComponent.classList.add('hidden');
            if (this.mediaModel) this.mediaModel.classList.remove('hidden');
          }
        } else if (this.mediaContainer && !target.classList.contains('product__swatch--more')) {
          if (this.hoverType == 'variant') {
            media = target.querySelector(`template[data-media='variant-image']`);
          } else if (this.hoverType == '0') {
            media = target.querySelector(`template[data-media='0']`);
          } else if (this.hoverType == '1') {
            media = target.querySelector(`template[data-media='1']`);
          }

          if (media) {
            this.mediaContainer.innerHTML = '';
            this.mediaContainer.appendChild(media.content.cloneNode(true));
          } else {
            this.mediaContainer.innerHTML = '';
            this.mediaContainer.appendChild(this.defaultMedia.content.cloneNode(true));
          }

          var video = this.mediaContainer.querySelector('video');
          this.ensureCardVideoAutoplay(video);
        }
      }

      const sliderList = this.link.querySelector('[id^="Slider-"]');
      if (sliderList) {
        sliderList.scrollLeft = 0;
      }

      if (target.querySelector('.product__swatch-price')) {
        var price = target.querySelector('.product__swatch-price').innerHTML;

        if (this.priceContainer) {
          this.priceContainer.innerHTML = price;
        }
      }
    }
  }

  onMouseOut(e) {
    // mouseout bubbles — ignore if the mouse is still within the swatch container
    if (this.contains(e.relatedTarget)) return;

    // Nothing to restore if no swatch was actually hovered
    if (!this._swatchHovered) return;
    this._swatchHovered = false;

    if (this.dataset.imageOverride && this.dataset.inLifestyleCollection == 'true') {
      // Restore the current product's lifestyle media when exiting hover
      if (this.viewAs) {
        if (this.lifestyleMediaProductHTML) {
          this.mediaProduct.innerHTML = this.lifestyleMediaProductHTML;
          this.ensureCardVideoAutoplay(this.mediaProduct.querySelector('video'));
        }
        if (this.lifestyleMediaModelHTML) {
          this.mediaModel.innerHTML = this.lifestyleMediaModelHTML;
          this.ensureCardVideoAutoplay(this.mediaModel.querySelector('video'));
        }
      } else if (this.mediaContainer) {
        if (this.lifestyleMediaHTML) {
          this.mediaContainer.innerHTML = this.lifestyleMediaHTML;
          const video = this.mediaContainer.querySelector('video');
          this.ensureCardVideoAutoplay(video);
        }
      }
    } else {
      // Use the original logic for regular media
      if (this.viewAs) {
        // Restore from saved original HTML (same source onCardLeave uses) — safe even if swatch templates haven't loaded
        if (this.originalMediaProductHTML !== null && this.mediaProduct) {
          this.mediaProduct.innerHTML = this.originalMediaProductHTML;
          this.ensureCardVideoAutoplay(this.mediaProduct.querySelector('video'));
        }
        if (this.originalMediaModelHTML !== null && this.mediaModel) {
          this.mediaModel.innerHTML = this.originalMediaModelHTML;
          this.ensureCardVideoAutoplay(this.mediaModel.querySelector('video'));
        }

        // Restore card-entered slider state after swatch mouseout
        const sliderList = this.link && this.link.querySelector('[id^="Slider-"]');
        if (sliderList) {
          sliderList.style.scrollBehavior = 'auto';
          sliderList.scrollLeft = 0;
        }
        if (this._cardEntered) {
          // Card image is still hovered — restore slider view
          if (this.viewAs.index === 0) {
            // PRODUCT mode: re-show slider, hide off-model static
            // Skip for simple cards — no desktop hover swap; slider is for mobile only
            if (this.sliderComponent && !(this.card && this.card.classList.contains('card--simple'))) {
              this.sliderComponent.classList.remove('hidden');
              if (this.mediaProduct) this.mediaProduct.classList.add('hidden');
            }
          } else if (this.viewAs.index === 1) {
            // MODEL mode: re-show slider (injected off-model slide still present), hide on-model static
            // Skip for simple cards — no desktop hover swap; slider is for mobile only
            if (this.sliderComponent && !(this.card && this.card.classList.contains('card--simple'))) {
              this.sliderComponent.classList.remove('hidden');
              if (this.mediaModel) this.mediaModel.classList.add('hidden');
            }
          }
        } else {
          // Card image is NOT hovered — keep static image visible, keep slider hidden
          if (this.viewAs.index === 0) {
            if (this.mediaProduct) this.mediaProduct.classList.remove('hidden');
          } else if (this.viewAs.index === 1) {
            if (this.mediaModel) this.mediaModel.classList.remove('hidden');
          }
        }
      } else if (this.mediaContainer) {
        if (this.defaultMedia) {
          this.mediaContainer.innerHTML = '';
          this.mediaContainer.appendChild(this.defaultMedia.content.cloneNode(true));
          this.ensureCardVideoAutoplay(this.mediaContainer.querySelector('video'));
        }
      }
    }

    if (this.priceContainer) {
      this.priceContainer.innerHTML = this.originalPrice;
    }
  }
}

customElements.define('card-swatches', CardSwatches);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  load() {
    this._requestId = (this._requestId || 0) + 1;
    const requestId = this._requestId;
    const requestUrl = this.dataset.url;

    fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        if (requestId !== this._requestId) return;
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        // Prefer matching the exact element by id when multiple
        const recommendations = html.getElementById(this.id) || html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        } else {
          this.innerHTML = '';
        }

        if (typeof Wishlist == 'object') {
          Wishlist.loadButtons();
        }

        if (this.hasAttribute('data-complete-look-recommendations')) {
          const sectionId = this.dataset.sectionId;
          const hasContent = this.innerHTML.trim().length > 0;
          const trigger = document.querySelector(
            `[data-complete-look-trigger][data-section-id="${sectionId}"]`
          );
          const drawer = document.querySelector(
            `[data-complete-look-drawer][data-section-id="${sectionId}"]`
          );

          if (trigger) trigger.hidden = !hasContent;
          if (drawer) drawer.hidden = !hasContent;
        }

        this.classList.add('loaded');
      })
      .catch((e) => {
        console.error(e);
      });
  }

  connectedCallback() {
    if (this.hasAttribute('data-complete-look-recommendations')) {
      this.load();
      return;
    }

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.load();
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class QuickviewTrigger extends HTMLElement {
  constructor() {
    super();

    this.handle = this.dataset.productHandle;
    this.productUrl = this.dataset.productUrl;
    this.sectionId = this.dataset.sectionId;

    this.addEventListener('click', this.getQuickview.bind(this));
  }

  updateHandle() {
    this.handle = this.dataset.productHandle;
  }

  getQuickview(e) {
    e.preventDefault();

    if (e.target.closest('.quickview--no-trigger')) {
      return;
    }

    let quickview_url = this.productUrl.indexOf('?') > 1 ? `${this.productUrl}&view=quickview` : `${this.productUrl}?view=quickview`;

    fetch(quickview_url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        var sizeGuide = html.querySelector('#SizeGuide-Quickview');

        if (sizeGuide) {
          document.body.appendChild(sizeGuide);
        }

        var quickview = html.querySelector('#Quickview');

        if (quickview) {
          document.body.appendChild(quickview);
          quickview.show(e.target);

          var details = quickview.querySelector('.product__view-details');

          if (details) {
            details.setAttribute('href', this.productUrl);
          }

          if (typeof Wishlist == 'object') {
            Wishlist.loadButtons();
          }
        }
      });
  }
}

customElements.define('quickview-trigger', QuickviewTrigger);

class QuickviewContainer extends HTMLElement {
  constructor() {
    super();

    this.gradient = this.querySelector('.quickview-gradient');

    this.close = this.querySelector('.product__view-close');

    this.drawer = this.querySelector('.quickview-drawer');

    if (this.gradient) {
      this.gradient.addEventListener('click', this.forceClose.bind(this));
    }

    if (this.close) {
      this.close.addEventListener('click', this.hide.bind(this));
    }

    this.drawer.addEventListener('touchstart', this.handleTouchStart.bind(this));

    this.drawer.addEventListener('touchend', this.handleTouchEnd.bind(this));
  }

  handleTouchStart(e) {
    if (e.changedTouches) {
      this.touch_start = e.changedTouches[0].screenX;
    } else {
      this.touch_start = e.screenX;
    }
  }

  handleTouchEnd(e) {
    if (e.changedTouches) {
      this.touch_end = e.changedTouches[0].screenX;
    } else {
      this.touch_end = e.screenX;
    }

    this.handleSwipe();
  }

  handleSwipe() {
    const delta = this.touch_start - this.touch_end;

    if (delta < -150) {
      this.hide();
    }
  }

  show(opener) {
    this.openedBy = opener;

    document.body.classList.add('overflow-hidden');
    document.body.classList.add('menu-drawer-open');

    setTimeout(() => {
      this.classList.add('quickview--open');
    }, 1);

    trapFocus(this, this.querySelector('[role="dialog"]'));

    Shopify.PaymentButton.init();
  }

  hide() {
    this.classList.remove('quickview--open');

    setTimeout(() => {
      document.body.classList.remove('overflow-hidden');
      document.body.classList.remove('menu-drawer-open');
      document.body.dispatchEvent(new CustomEvent('modalClosed'));

      removeTrapFocus(this.openedBy);
      //window.pauseAllMedia();

      this.remove();

      var sizeGuide = document.querySelector('#SizeGuide-Quickview');

      if (sizeGuide) {
        sizeGuide.remove();
      }
    }, 300);
  }

  forceClose(e) {
    if (e.target === this.gradient) {
      this.hide();
    }
  }
}

customElements.define('quickview-container', QuickviewContainer);

class QuickAdd extends HTMLElement {
  constructor() {
    super();

    this.idSelector = this.querySelector(`[name='QuickaddId']`);
    this.button = this.querySelector(`[name='QuickaddButton']`);

    if (!this.button) {
      return;
    }

    this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (document.querySelector('cart-drawer')) {
      this.button.setAttribute('aria-haspopup', 'dialog');
    }

    this.button.addEventListener('click', this.addToCart.bind(this));
  }

  addToCart(e) {
    e.preventDefault();

    if (this.idSelector.value == '') {
      this.classList.add('error');

      setTimeout(() => {
        this.classList.remove('error');
      }, 3000);
    } else {
      this.button.setAttribute('aria-disabled', true);
      this.button.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      const formData = {
        items: [
          {
            id: this.idSelector.value,
          },
        ],
      };

      if (this.cart) {
        formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
      }

      fetch(`/cart/add`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/json` },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((response) => {
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');

          this.button.classList.remove('loading');
          this.button.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
    }
  }
}

customElements.define('quick-add', QuickAdd);

window.PaginationInfinite = window.PaginationInfinite || (() => {
  const selectors = {
    pagination: '[data-pagination]',
    loadMore: '[data-load-more]',
    loadMoreButton: '[data-load-more-button]',
    status: '[data-load-more-status]',
    sentinel: '[data-load-more-sentinel]',
    grid: '#product-grid',
  };

  const state = new WeakMap();
  const supportsIO = 'IntersectionObserver' in window;
  const urlParams = new URLSearchParams(window.location.search);
  const disableInfiniteFromUrl = urlParams.get('no_infinite') === '1';

  const getNextUrl = (pagination) => pagination.getAttribute('data-next-url');

  const setNextUrl = (pagination, url) => {
    if (url) {
      pagination.setAttribute('data-next-url', url);
    } else {
      pagination.removeAttribute('data-next-url');
    }
  };

  const setLoadingState = (pagination, isLoading) => {
    const button = pagination.querySelector(selectors.loadMoreButton);
    const status = pagination.querySelector(selectors.status);
    const listing = pagination.closest('.listing');

    if (listing) listing.classList.toggle('loading', isLoading);

    if (button) {
      button.classList.toggle('loading', isLoading);
      if (isLoading) {
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('aria-disabled');
      }
    }

    if (status) {
      status.textContent = '';
    }
  };

  const updateControls = (pagination) => {
    const loadMore = pagination.querySelector(selectors.loadMore);
    const hasNext = Boolean(getNextUrl(pagination));
    if (!loadMore) return;

    const isManual = pagination.dataset.disableInfinite === 'true';
    const showFallback = isManual || !supportsIO || pagination.dataset.atBottom === 'true';
    loadMore.hidden = !hasNext || !showFallback;
  };

  const isSentinelInView = (sentinel) => {
    if (!sentinel) return false;
    const rect = sentinel.getBoundingClientRect();
    return rect.top <= window.innerHeight + 200 && rect.bottom >= -200;
  };

  const setupScrollFallback = (pagination, sentinel) => {
    const existing = state.get(pagination);
    if (existing && existing.scrollHandler) return;

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        if (!document.body.contains(pagination)) {
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          return;
        }

        const inView = isSentinelInView(sentinel);
        pagination.dataset.atBottom = inView ? 'true' : 'false';
        updateControls(pagination);
        if (inView) loadMore(pagination);
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    state.set(pagination, { ...(existing || {}), scrollHandler: onScroll });
  };

  const loadMore = (pagination) => {
    const nextUrl = getNextUrl(pagination);
    if (!nextUrl || pagination.dataset.loading === 'true') return;

    pagination.dataset.loading = 'true';
    setLoadingState(pagination, true);
    updateControls(pagination);

    fetch(nextUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const parsed = new DOMParser().parseFromString(responseText, 'text/html');
        const newGrid = parsed.querySelector(selectors.grid);
        const currentGrid = document.querySelector(selectors.grid);

        if (newGrid && currentGrid) {
          const appendedItems = Array.from(newGrid.children);
          appendedItems.forEach((item) => currentGrid.appendChild(item));

          // Defer toggle reloads by one frame so the browser can process custom-element
          // upgrades and their fetch() calls before hero injection adds more DOM work.
          // ViewAsToggle.load() now skips re-activation for already-enhanced cards so
          // this reload is safe to call without resetting swiped carousels.
          // Future: if rapid sentinel re-fires cause performance issues, add a debounce
          // or cooldown here (e.g. skip reload if last reload was < 200ms ago).
          requestAnimationFrame(() => {
            const viewAsToggle = document.querySelector('view-as-toggle');
            if (viewAsToggle) viewAsToggle.reload();

            const viewByToggle = document.querySelector('view-by-toggle');
            if (viewByToggle) viewByToggle.reload();
          });
        }

        const newPagination = parsed.querySelector(selectors.pagination);
        const newNextUrl = newPagination ? newPagination.getAttribute('data-next-url') : null;
        setNextUrl(pagination, newNextUrl);
        updateControls(pagination);

        if (!newNextUrl) {
          const existing = state.get(pagination);
          if (existing && existing.observer) existing.observer.disconnect();
          if (existing && existing.scrollHandler) {
            window.removeEventListener('scroll', existing.scrollHandler);
            window.removeEventListener('resize', existing.scrollHandler);
          }
        }

        if (window.Wishlist && typeof window.Wishlist.loadButtons === 'function') {
          window.Wishlist.loadButtons();
        }

        if (typeof initializeScrollAnimationTrigger === 'function') {
          initializeScrollAnimationTrigger(document);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        pagination.dataset.loading = 'false';
        setLoadingState(pagination, false);
        updateControls(pagination);
      });
  };

  const initPagination = (pagination) => {
    if (!pagination) return;

    pagination.classList.add('pagination-wrapper--infinite');
    if (disableInfiniteFromUrl) {
      pagination.dataset.disableInfinite = 'true';
    }
    updateControls(pagination);
    const button = pagination.querySelector(selectors.loadMoreButton);
    if (button) {
      const existing = state.get(pagination);
      if (!existing || !existing.buttonHandler) {
        const buttonHandler = (event) => {
          event.preventDefault();
          loadMore(pagination);
        };
        button.addEventListener('click', buttonHandler);
        state.set(pagination, { ...(existing || {}), buttonHandler });
      }
    }

    const sentinel = pagination.querySelector(selectors.sentinel);
    if (pagination.dataset.disableInfinite === 'true') return;
    const canObserve = supportsIO && sentinel;
    const existing = state.get(pagination);

    if (canObserve && !(existing && existing.observer)) {
      const observer = new IntersectionObserver(
        (entries) => {
          const isIntersecting = entries.some((entry) => entry.isIntersecting);
          pagination.dataset.atBottom = isIntersecting ? 'true' : 'false';
          if (isIntersecting) loadMore(pagination);
        },
        { rootMargin: '200px 0px 200px 0px' }
      );
      observer.observe(sentinel);
      state.set(pagination, { ...(existing || {}), observer });
    }

    if (sentinel) {
      setupScrollFallback(pagination, sentinel);
    }
  };

  const init = () => {
    document.querySelectorAll(selectors.pagination).forEach(initPagination);
  };

  let clickDelegateAttached = false;
  const setupClickDelegate = () => {
    if (clickDelegateAttached) return;
    clickDelegateAttached = true;
    document.addEventListener('click', (event) => {
      const button = event.target.closest(selectors.loadMoreButton);
      if (!button) return;
      event.preventDefault();
      const pagination = button.closest(selectors.pagination);
      if (!pagination) return;
      loadMore(pagination);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      setupClickDelegate();
    });
  } else {
    init();
    setupClickDelegate();
  }

  const manualLoadMore = (button) => {
    const pagination = button && button.closest ? button.closest(selectors.pagination) : document.querySelector(selectors.pagination);
    if (!pagination) return false;
    loadMore(pagination);
    return true;
  };

  return { init, manualLoadMore };
})();
